import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import globalIP from '../../../GlobelIP';
import Resizer from 'react-image-file-resizer';
import PlusIcon from '@rsuite/icons/Plus';
import RemindIcon from '@rsuite/icons/legacy/Remind';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchMaterialCollection,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes,
  fetchComponent,
  fetchShape,
  fetchSeason,
  fetchPtechnique
} from '../../../apiService/apiService';
import {
  Container,
  CheckPicker,
  Breadcrumb,
  Button,
  Divider,
  Table,
  Message,
  Col,
  useToaster,
  Stack,
  Steps,
  Panel,
  FlexboxGrid,
  Form,
  Input,
  InputNumber,
  SelectPicker,
  InputPicker,
  IconButton,
  ButtonGroup,
  Toggle,
  Modal,
  Tooltip,
  Whisper,
  Loader
} from 'rsuite';
import usecustHook from '../hook/CustHook';
import { Player } from '@lottiefiles/react-lottie-player';
import animati from '../animation/AnimProduct.json';
import ugr from '@/UGRoute';
import VariantPacking from './VariantPacking';
import ImageSection from './CreateProduct/ImageSection';
import ProductFamily from './CreateProduct/ProductFamily';
import PackageLoadability from './CreateProduct/PackageLoadability';
import Footer from '@/components/Footer/Footer';
import ProductionDetails from './CreateProduct/ProductionDetails';
import BuyerExclusiveProduct from './CreateProduct/BuyerExclusiveProduct';
import StackItem from 'rsuite/esm/Stack/StackItem';
import Port from '../../../Port';
import { Skeleton, Spin } from 'antd';
const { hostname } = window.location;
// const hostname = '192.168.1.19';
function PreventOverflowContainer({ children, height = 500 }) {
  const container = React.useRef();
  const content = React.useRef();

  const containerStyle = {
    overflow: 'auto',
    position: 'relative'
  };

  const contentStyle = {
    height: '400%',
    width: '230%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap'
  };

  React.useEffect(() => {
    container.current.scrollTop = content.current.clientHeight / 2 - 60;
    container.current.scrollLeft =
      content.current.clientWidth / 2 - container.current.clientWidth / 2;
  }, [container, content]);

  return (
    <div style={{ ...containerStyle, height }} ref={container}>
      <div style={contentStyle} ref={content}>
        {children(() => container.current)}
      </div>
    </div>
  );
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const Textarea = React.forwardRef(props => <Input {...props} as="textarea" />);

interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: 'Inch';
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    Shape: null;
    Season: null;
    P_Technique: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    Variant: null;
    SetStatus: string;
    Part: 0;
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    ProductionDetail: [
      {
        id: string;
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: 0;
        MaterialCode: string;
        MaterialFinishCode: string;
      }
    ];
    SetSizes: [
      {
        id: string;
        SizeUnit: 0;
        Length: 0;
        Width: 0;
        Height: 0;
        cbm: 0;
      }
    ];
    // Add other attributes if needed
  };
}

const size = [
  { label: 'CM', value: 'cm' },
  { label: 'Inch', value: 'inch' }
];
const cartontype = [
  { label: 'Master', value: 'master' },
  { label: 'Inner', value: 'inner' }
];
const setstatus = [
  { label: 'Single', value: 'Single' },
  { label: 'Set', value: 'Set' }
];

const { Column, HeaderCell, Cell } = Table;
const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

let categoryCodeCounter = 1;
const Addprduct = () => {
  const history = useNavigate()
  const ip = globalIP;
  const [showInputs, setShowInputs] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [result, setResult] = useState<any | null>(null);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('showPopup') === 'true') {
      setOpen4(true);
    }
  }, [location]);
  const {
    submit1,
    handleInputChangemstcat,
    category,
    submit3,
    handleInputChange3,
    collection,
    submit4,
    handleInputChange4,
    finish,
    submit5,
    handleInputChange5,
    color,
    submit6,
    handleInputChange6,
    hscode,
    submit7,
    handleInputChange7,
    material,
    submit8,
    handleInputChange8,
    shape,
    submit9,
    handleInputChange9,
    season,
    submit10,
    handleInputChange10,
    ptech,
    submit2,
    handleInputChange2,
    productType,
    selectedFinishName,
    setSelectedFinishName,
    selectedColorName,
    setSelectedColorName
  } = usecustHook(selectedCategoryCode);
  // utils/cookieUtils.js
  const clearCookies = () => {
    document.cookie.split(';').forEach(cookie => {
      document.cookie = cookie.replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
  };

  // add number end
  const toaster = useToaster();
  const [fileInfo, setFileInfo] = React.useState(null);
  const [orginalImg, setOrginalImg] = React.useState(null);
  const [varit, setVarit] = React.useState(0);

  // stap code start
  const [step, setStep] = React.useState(0);
  const onChange = nextStep => {
    setStep(nextStep < 0 ? 0 : nextStep > 2 ? 2 : nextStep);
  };
  const [alias, setAlias] = useState('');
  const [data1234, setData1234] = useState<RowData[]>([]);

  // const onNext = async () => {
  //   setUpdateId(tempUpdateid);
  //   const updateid = tempUpdateid;

  //   const varpd = variantData.map(id => id.ProductId).join('&');
  //   const selectedItemsArray = varpd.split(',').filter(id => id);
  //   const productvarid = selectedItemsArray.map(id => `filters[ProductId][$eqi]=${id}`).join('&');

  //   const { data: aliasData } = await axios.get(
  //     `${globalIP}/api/products?populate=*&filters[ProductId][$eqi]=${data5.ProductId.trim()}&${productvarid}`
  //   );
  //   const { data: valiasData } = await axios.get(
  //     `${globalIP}/api/variant-products?populate=*&filters[ProductId][$eqi]=${data5.ProductId.trim()}&${productvarid}`
  //   );

  //   const dataCode = [...aliasData.data, ...valiasData.data];
  //   const productAndVari = [...data123, ...data1234];

  //   // --- ALL YOUR VALIDATIONS REMAIN EXACTLY THE SAME ---
  //   if (data5.CategoryCode == '') {
  //     toaster.push(<Message showIcon type="error">Please add Category.</Message>, { placement: 'topCenter' });
  //     return;
  //   }
  //   if (data5.CoverImage == null) {
  //     toaster.push(<Message showIcon type="error">Please add atleast one Product Image.</Message>, { placement: 'topCenter' });
  //     return;
  //   }
  //   if (data5.ProductId == '') {
  //     toaster.push(<Message showIcon type="error">Please add {label[0]?.attributes?.AliasCode}.</Message>, { placement: 'topCenter' });
  //     return;
  //   }
  //   if (data5.ProductName.trim() == '') {
  //     toaster.push(<Message showIcon type="error">Please add Product Name.</Message>, { placement: 'topCenter' });
  //     return;
  //   }
  //   if (dataCode.length && (updateid === '' || updateid === null) && data5.ProductId.trim() !== updateid.trim()) {
  //     toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} already exists.</Message>, { placement: 'topCenter' });
  //     return;
  //   }
  //   if (!/^[a-zA-Z0-9\-,]+$/.test(data5.ProductId.trim())) {
  //     toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} should not contain special characters.</Message>, { placement: 'topCenter' });
  //     return;
  //   }

  //   // --- NO CHANGES TO YOUR LOGIC ---
  //   if (data5.ProductId.trim().toLowerCase() !== alias.trim().toLowerCase()) {
  //     if (dataCode.length) {
  //       toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} already exists.</Message>, { placement: 'topCenter' });
  //       return;
  //     }
  //   }

  //   // --- SAME VARIANT VALIDATIONS ---
  //   if (step === 1 || step === 2) {
  //     if (numVariants > 0 && addingVariants && !variantImageChanged) {
  //       toaster.push(<Message showIcon type="error">Please change all variant image.</Message>, { placement: 'topCenter' });
  //       return;
  //     }

  //     for (let variant of variantData) {
  //       if (variant.ProductId === '') {
  //         toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} Required.</Message>, { placement: 'topCenter' });
  //         return;
  //       }
  //     }

  //     const duplicatesVid = variantData.filter(
  //       (variant, index, self) => self.findIndex(vid => vid.ProductId.trim() === variant.ProductId.trim()) !== index
  //     );

  //     if (duplicatesVid.length > 0) {
  //       toaster.push(
  //         <Message showIcon type="error">Duplicate Variant {label[0]?.attributes?.AliasCode} found: {duplicatesVid.map(v => v.ProductId.trim()).join(', ')}</Message>,
  //         { placement: 'topCenter' }
  //       );
  //       return;
  //     }

  //     const conflictFound = variantData.some(variant =>
  //       productAndVari.some(
  //         product => product.attributes.ProductId.trim().toLowerCase() === variant.ProductId.trim().toLowerCase()
  //       )
  //     );

  //     if (conflictFound) {
  //       toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} already exists.</Message>, { placement: 'topCenter' });
  //       return;
  //     }
  //   }

  //   // --- FIXED STEP NAVIGATION (NO DOM MANIPULATION) ---
  //   onChange(step + 1);
  // };

  const onNext = async () => {
    setUpdateId(tempUpdateid);
    const updateid = tempUpdateid;

    const varpd = variantData.map(id => id.ProductId).join('&');
    const selectedItemsArray = varpd.split(',').filter(id => id);
    const productvarid = selectedItemsArray.map(id => `filters[ProductId][$eqi]=${id}`).join('&');

    const { data: aliasData } = await axios.get(
      `${globalIP}/api/products?populate=*&filters[ProductId][$eqi]=${data5.ProductId.trim()}&${productvarid}`
    );
    const { data: valiasData } = await axios.get(
      `${globalIP}/api/variant-products?populate=*&filters[ProductId][$eqi]=${data5.ProductId.trim()}&${productvarid}`
    );

    const dataCode = [...aliasData.data, ...valiasData.data];
    const productAndVari = [...data123, ...data1234];

    // --- ALL OLD VALIDATIONS KEPT AS IS ---
    if (data5.CategoryCode == '') {
      toaster.push(<Message showIcon type="error">Please add Category.</Message>, { placement: 'topCenter' });
      return;
    }
    if (data5.CoverImage == null) {
      toaster.push(<Message showIcon type="error">Please add atleast one Product Image.</Message>, { placement: 'topCenter' });
      return;
    }
    if (data5.ProductId == '') {
      toaster.push(<Message showIcon type="error">Please add {label[0]?.attributes?.AliasCode}.</Message>, { placement: 'topCenter' });
      return;
    }
    if (data5.ProductName.trim() == '') {
      toaster.push(<Message showIcon type="error">Please add Product Name.</Message>, { placement: 'topCenter' });
      return;
    }
    if (dataCode.length && (updateid === '' || updateid === null) && data5.ProductId.trim() !== updateid.trim()) {
      toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} already exists.</Message>, { placement: 'topCenter' });
      return;
    }
    if (!/^[a-zA-Z0-9\-,]+$/.test(data5.ProductId.trim())) {
      toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} should not contain special characters.</Message>, { placement: 'topCenter' });
      return;
    }

    if (data5.ProductId.trim().toLowerCase() !== alias.trim().toLowerCase()) {
      if (dataCode.length) {
        toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} already exists.</Message>, { placement: 'topCenter' });
        return;
      }
    }

    // ---- VARIANT VALIDATION (unchanged) ----
    if (step === 1 || step === 2) {
      // if (numVariants > 0 && addingVariants && !variantImageChanged) {
      //   toaster.push(<Message showIcon type="error">Please change all variant image.</Message>, { placement: 'topCenter' });
      //   return;
      // }

      for (let variant of variantData) {
        if (variant.ProductId === '') {
          toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} Required.</Message>, { placement: 'topCenter' });
          return;
        }
      }

      const duplicatesVid = variantData.filter(
        (variant, index, self) => self.findIndex(vid => vid.ProductId.trim() === variant.ProductId.trim()) !== index
      );

      if (duplicatesVid.length > 0) {
        toaster.push(
          <Message showIcon type="error">
            Duplicate Variant {label[0]?.attributes?.AliasCode} found: {duplicatesVid.map(v => v.ProductId.trim()).join(', ')}
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const conflictFound = variantData.some(variant =>
        productAndVari.some(
          product => product.attributes.ProductId == variant.ProductId
        )
      );

      if (conflictFound) {
        toaster.push(<Message showIcon type="error">{label[0]?.attributes?.AliasCode} already exists.</Message>, { placement: 'topCenter' });
        return;
      }
    }

    // --- ONLY STEP FIXED (UI remains unchanged) ---
    onChange(step + 1);

    // KEEP OLD DIV SHOW/HIDE — only triggered by step changes
  };

  const onPrevious = () => {
    const prev = step - 1;

    // Prevent going below Step 0
    if (prev < 0) return;

    onChange(prev);
  };


  // stap code end
  const [data5, setData5] = useState({
    CategoryCode: '',
    ProductTypeCode: '',
    ProductCode: '',
    ProductId: '',
    ProductName: '',
    Description: '',
    SizeUnit: 'inch',
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: '',
    ColorCode: '',
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: '',
    SellingPriceCurrency: '',
    SellingPriceUnit: '',
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: '',
    MOQ: 0,
    ProductDesigner: '',
    MadeBy: '',
    CategoryName: '',
    ProductTypeName: '',
    cbm: 0,
    Shape: '',
    Season: '',
    P_Technique: '',
    FinishName: '',
    ColorName: '',
    BuyerName: '',
    BuyerSku: '',
    SizeRange: '',
    Product_Remark: '',
    Buyer_Remark: '',
    Variant: 'false',
    SetStatus: 'Single',
    Part: '1',
    Authorized: '',
    L: 0,
    M: 0,
    MX: 0,
    MaterialCollection: [
      {
        ProductCode: '',
        MatCollectionNm: '',
        MatCollectionCode: ''
      }
    ],
    ProductionDetail: [
      {
        ProductCode: '',
        MaterialNm: '',
        MaterialFinishNm: '',
        MatNetWeight: 0,
        MaterialCode: '',
        MaterialFinishCode: '',
        Component: '',
        Unit: 'inch',
        Length: 0,
        Width: 0,
        Height: 0,
        Depth: 0,
        Qty: 0,
        Remark: ''
      }
    ],
    CoverImage: null,
    MultipleImage: null,
    threeDview: null,
    Total_CBM: 0,
    Total_CFT: 0,
    TwentyFT: '',
    FortyFT: '',
    FortyHQ: '',
    Packaging: [
      {
        CartonType: 'master',
        ProductCode: '',
        Carton_Unit: 'inch',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 1,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      }
    ],
    SetSizes: [
      {
        SizeUnit: 'inch',
        SetRate: 0,
        Length: 0,
        Width: 0,
        Height: 0,
        cbm: 0,
        Description: '',
        ColorName: '',
        ColorCode: '',
        FinishName: '',
        FinishCode: '',
        NetWt: 0,
        MatName: ''
      }
    ]
  });
  const [costinghead, setCostingHead] = useState({
    L: 0,
    M: 0,
    X: 0
  });
  useEffect(() => {
    fetchData11();
  }, []);
  const fetchData11 = async () => {
    try {
      const response = await fetch(`${globalIP}/api/costingheads?populate=*`);
      const jsonData = await response.json();
      // Assuming you have a valid data structure
      const cheadata = jsonData?.data[0]; // Adjust index based on API response
      if (cheadata) {
        setCostingHead({
          L: cheadata.attributes?.L || 0,
          M: cheadata.attributes?.M || 0,
          X: cheadata.attributes?.X || 0
        });
      }
    } catch (error) {
      console.error('Error fetching costing heads:', error);
    }
  };

  const fetchNewCatName = async CategoryCode => {
    const response = await fetch(`${ip}/api/mstcategories?filters[CategoryCode]=${CategoryCode}`);
    const json = await response.json();
    return json?.data[0]?.attributes?.CategoryName;
  };
  const fetchNewPTypeName = async ProductTypeCode => {
    const response = await fetch(
      `${ip}/api/mstproducttypes?filters[ProductTypeCode]=${ProductTypeCode}`
    );
    const json = await response.json();
    return json?.data[0]?.attributes?.ProductTypeName; // Update the CategoryName field
  };
  const fetchNewColorName = async ColorCode => {
    const response = await fetch(`${ip}/api/mstcolors?filters[ColorCode]=${ColorCode}`);
    const json = await response.json();
    return json?.data[0]?.attributes?.ColorName; // Update the CategoryName field
  };
  const fetchNewFinishName = async FinishCode => {
    const response = await fetch(`${ip}/api/mstfinishes?filters[FinishCode]=${FinishCode}`);
    const json = await response.json();
    return json?.data[0]?.attributes?.FinishName; // Update the CategoryName field
  };
  const fetchNewMaterialName = async MaterialCode => {
    const response = await fetch(`${ip}/api/mstmaterials?filters[MaterialCode]=${MaterialCode}`);
    const json = await response.json();
    return json?.data[0]?.attributes?.MaterialName; // Update the CategoryName field
  };
  const fetchNewMaterialCollName = async MatCollectionCode => {
    const response = await fetch(
      `${ip}/api/mstmaterialcollections?filters[MatCollectionCode]=${MatCollectionCode}`
    );
    const json = await response.json();
    return json?.data[0]?.attributes?.MatCollectionName; // Update the CategoryName field
  };
  const [siii, setSiii] = useState([
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ]);
  const authstatus = [
    { label: 'Authorised', value: 'Authorised' },
    { label: 'Pending', value: 'Pending' }
  ];
  //////// product fetch start ////////
  const [productdata, setProductdata] = useState(0);
  useEffect(() => {
    fetchData0();
    clearCookies();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${ip}/api/products?populate=*&publicationState=preview`);
    const json = await response.json();
    setProductdata(json.meta.pagination.total);
  };

  const generateNextCategoryCode = () => {
    const nextCode = productdata + 1;
    return `PRD-${nextCode.toString().padStart(3, '0')}`;
  };

  const addMaterial = () => {
    setData5(prevData => {
      const newPackaging = {
        ProductCode: '',
        MaterialNm: '',
        MaterialFinishNm: '',
        MatNetWeight: 0,
        MaterialCode: '',
        MaterialFinishCode: '',
        Component: '',
        Unit: 'inch',
        Length: 0,
        Width: 0,
        Height: 0,
        Depth: 0,
        Qty: 0,
        Remark: ''
      };
      return {
        ...prevData,
        ProductionDetail: [...prevData.ProductionDetail, newPackaging]
      };
    });
  };

  const addPackaging = () => {
    setData5(prevData => {
      const newPackaging = {
        CartonType: '',
        ProductCode: generateNextCategoryCode(),
        Carton_Unit: 'inch',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 1,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      };

      return {
        ...prevData,
        Packaging: [...prevData.Packaging, newPackaging]
      };
    });
  };

  const [totalcbm1, setTotalCbm] = useState(0);
  const [totalcft, setTotalCFT] = useState(0);
  const [feet20, setFeet20] = useState<any | null>(0);
  const [feet40, setFeet40] = useState<any | null>(0);
  const [feet20hc, setFeet20hc] = useState<any | null>(0);

  const [currentSizeUnit, setCurrentSizeUnit] = useState(data5.SizeUnit);

  useEffect(() => {
    // Calculate CBM whenever SizeUnit, Length, Width, or Height changes
    const calculateCBM = () => {
      const { SizeUnit, Length, Width, Height } = data5;

      // Convert dimensions to a common unit (e.g., meters)
      const unitConversionFactor = SizeUnit === 'cm' ? 1 / 1000000 : 1 / 61023;
      const productcbm3 = Length * Width * Height * unitConversionFactor;
      setResult(productcbm3.toFixed(4));
      setData5(prevData => {
        return {
          ...prevData,
          cbm: productcbm3.toFixed(4)
        };
      });
    };
    // Update SizeUnit in the state when it changes
    if (currentSizeUnit !== data5.SizeUnit) {
      setCurrentSizeUnit(data5.SizeUnit);
    }
    // Calculate CBM whenever relevant values change
    calculateCBM();
  }, [data5.SizeUnit, data5.Length, data5.Width, data5.Height]);
  useEffect(() => {
    // Function to calculate CBM for each item in SetSizes
    const calculateCBM = () => {
      setData5(prevData => {
        const updatedSetSizes = prevData?.SetSizes?.map(item => {
          const { SizeUnit, Length, Width, Height } = item;

          // Determine conversion factor based on SizeUnit
          const unitConversionFactor = SizeUnit === 'cm' ? 1 / 1000000 : 1 / 61023;

          // Calculate CBM
          const cbm = (Length || 0) * (Width || 0) * (Height || 0) * unitConversionFactor;

          return {
            ...item,
            cbm: parseFloat(cbm.toFixed(4)) // Update CBM with 4 decimal precision
          };
        });

        return {
          ...prevData,
          SetSizes: updatedSetSizes
        };
      });
    };

    calculateCBM();
  }, [data5.SetSizes]); // Depend on SetSizes to recalculate when it changes

  const [openne, setOpenne] = useState(false);
  const handleOpenne = () => setOpenne(true);
  const handleClosene = () => setOpenne(false);
  const [pendingProductId, setPendingProductId] = useState('');
  useEffect(() => {
    if (!pendingProductId) return;

    const timer = setTimeout(async () => {
      const res = await fetch(`${ip}/api/products?filters[ProductId][$eq]=${pendingProductId}`);
      const json = await res.json();
      if (json?.data?.length > 0) {
        toaster.push(
          <Message type="error" showIcon>
            Style No "{pendingProductId}" already exists. Please choose a different one.
          </Message>
        );
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [pendingProductId]);
  const handleInputChange = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    const updatedValue = value === null ? '' : value;
    if (inputName === 'MaterialCollection') {
      const mat = collectiondata.filter(item => {
        if (value.includes(item.label)) {
          return item;
        }
      });
      const selectedCollections = (mat || []).map((item, i) => ({
        ProductCode: updateid ? data5.ProductCode : generateNextCategoryCode(),
        MatCollectionNm: (item.label && item.label.trim()) || '', // Perform a null check before calling trim()
        MatCollectionCode: (item.value && item.value.trim()) || ''
      }));
      setData5(prevData => ({
        ...prevData,
        MaterialCollection: selectedCollections
      }));
    } else if (
      inputName === 'Length' ||
      inputName === 'Width' ||
      inputName === 'Height' ||
      inputName === 'NetWeight' ||
      inputName === 'GrossWeight' ||
      inputName === 'cbm'
    ) {
      // Check for negative values and prevent them
      if (parseFloat(value) < 0) {
        handleOpenne();
        return; // Prevent setting negative value in state
      }

      // Update state only if the value is not negative
      setData5(prevData => ({
        ...prevData,
        [inputName]: value
      }));
    } else if (inputName === 'MOQ') {
      // If value is cleared, set it to 0
      const numericValue = value === '' ? 0 : parseInt(value);

      // Prevent negative values
      if (numericValue < 0) {
        return; // Simply exit without showing any error UI
      }

      // Update the state with the valid numeric value
      setData5(prevData => ({
        ...prevData,
        [inputName]: numericValue
      }));
    } else if (inputName === 'CategoryName') {
      const selectedCategory = categorydata.find(item => item.label === value);
      if (aliasauto == 'Manual') {
        // If aliasauto is false, update only CategoryName and CategoryCode
        setData5(prevData => ({
          ...prevData,
          CategoryName: value,
          CategoryCode: selectedCategory ? selectedCategory.value : ''
        }));
        setSelectedCategory(selectedCategory || null);
        setSelectedCategoryCode(selectedCategory ? selectedCategory.value : '');
      } else {
        // If aliasauto is true, fetch products for the selected category
        if (selectedCategory) {
          fetch(`${ip}/api/products?filters[CategoryCode][$eq]=${selectedCategory.value}`)
            .then(response => response.json())
            .then(json => {
              const products = json.meta?.pagination?.total || 0;
              // const totalProductsInCategory = products.length;

              // Construct ProductId based on sname and total products in the category
              const productId = selectedCategory.sname
                ? `${selectedCategory.sname}-${products + 1}`
                : `${products + 1}`;

              // Update state
              setData5(prevData => ({
                ...prevData,
                CategoryName: value,
                CategoryCode: selectedCategory.value,
                ProductId: productId
              }));
            })
            .catch(error => {
              console.error('Error fetching products:', error);
            });
        }
      }
      setSelectedCategory(selectedCategory || null);
      setSelectedCategoryCode(selectedCategory ? selectedCategory.value : '');
    } else if (inputName === 'ProductId') {
      const newProductId = value;
      if (aliasauto == 'Cate.Shortname + Manual') {
        // Allow editing but only the number part after the dash
        const prefix = `${selectedCategory.sname}-`;
        if (newProductId.startsWith(prefix)) {
          const editablePart = newProductId.substring(prefix.length);

          // Optional: add further validation if needed, e.g. is the editable part numeric?
          if (/^\d*$/.test(editablePart)) {
            setData5(prev => ({
              ...prev,
              [inputName]: newProductId
            }));
            setPendingProductId(newProductId);
          } else {
            toaster.push(
              <Message type="warning">
                Only the numeric part of the ProductId can be edited.
              </Message>
            );
          }
        } else {
          toaster.push(
            <Message type="warning">You can only edit the number part after "${prefix}"</Message>
          );
        }
      } else {
        setData5({ ...data5, [inputName]: newProductId });
        setPendingProductId(newProductId);
      }
    } else if (inputName === 'ProductTypeName') {
      const selectedPtype = productypedata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        ProductTypeName: value,
        ProductTypeCode: selectedPtype ? selectedPtype.value : ''
      }));
    } else if (inputName === 'ColorName') {
      const selectedColor = colordata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        ColorName: value,
        ColorCode: selectedColor ? selectedColor.value : ''
      }));
    } else if (inputName === 'FinishName') {
      const selectedFinish = finishdata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        FinishName: value,
        FinishCode: selectedFinish ? selectedFinish.value : ''
      }));
    } else if (inputName.startsWith('MaterialFinishNm')) {
      // Handling MaterialFinishNm input change
      const materialIndex = inputName.split('_')[1];
      const selectedFinish = finishdata.find(item => item.label === updatedValue);

      setData5(prevData => {
        const updatedMaterials = [...prevData.ProductionDetail];
        updatedMaterials[materialIndex].MaterialFinishNm = updatedValue;
        updatedMaterials[materialIndex].MaterialFinishCode = selectedFinish
          ? selectedFinish.updatedValue
          : '';
        return {
          ...prevData,
          ProductionDetail: updatedMaterials
        };
      });
    } else if (inputName.startsWith('MatNetWeight')) {
      // Handling MatNetWeight input change
      const materialIndex = inputName.split('_')[1];
      setData5(prevData => {
        const updatedMaterials = [...prevData.ProductionDetail];
        updatedMaterials[materialIndex].MatNetWeight = parseFloat(value);
        return {
          ...prevData,
          ProductionDetail: updatedMaterials
        };
      });
    } else if (inputName.startsWith('Carton_GrsWt')) {
      // Handling Carton_GrsWt input change
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_GrsWt = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
    } else if (inputName === 'SellingPriceCurrency') {
      // console.log(data5)
      // When currency is selected
      const selectedCurrency = curr.find(currency => currency.value === value);
      if (selectedCurrency) {
        // Set exchangerate in SellingPriceUnit+
        const newSellingPrice = data5.SellingPrice || 0;
        const newProductCost = newSellingPrice * selectedCurrency.exchangerate;
        setData5(prevData => ({
          ...prevData,
          SellingPriceCurrency: value,
          SellingPriceUnit: String(selectedCurrency.exchangerate),
          ProductCost: parseFloat(newProductCost.toFixed(2))
        }));
      }
    } else if (inputName === 'SellingPriceUnit' || inputName === 'SellingPrice') {
      const newSellingPriceUnit = inputName === 'SellingPriceUnit' ? value : data5.SellingPriceUnit;
      const newSellingPrice = inputName === 'SellingPrice' ? value : data5.SellingPrice;
      // Check for negative values for SellingPriceUnit and SellingPrice
      if (newSellingPriceUnit >= 0 && newSellingPrice >= 0) {
        // Calculate the new ProductCost
        // Calculate L, M, MX prices using costinghead percentages
        const newL = parseFloat((newSellingPrice * (1 + costinghead.L / 100)).toFixed(2));
        const newM = parseFloat((newSellingPrice * (1 + costinghead.M / 100)).toFixed(2));
        const newMX = parseFloat((newSellingPrice * (1 + costinghead.X / 100)).toFixed(2));
        let newProductCost = newSellingPriceUnit * newSellingPrice;
        newProductCost = parseFloat(newProductCost.toFixed(2));
        setData5(prevData => ({
          ...prevData,
          SellingPriceUnit: newSellingPriceUnit,
          SellingPrice: newSellingPrice,
          ProductCost: newProductCost,
          L: newL,
          M: newM,
          MX: newMX
        }));
      } else {
        handleOpenne();
      }
    } else if (inputName === 'Part') {
      // Handle dynamic rows for SetSizes
      const partValue = parseInt(value, 10) || 1;
      setData5(prevData => {
        const updatedData = { ...prevData, Part: value };

        if (partValue > prevData.SetSizes.length) {
          // Add rows if Part is greater
          const additionalRows = Array.from(
            { length: partValue - prevData.SetSizes.length },
            () => ({
              SizeUnit: 'inch',
              Length: 0,
              Width: 0,
              Height: 0,
              cbm: 0,
              NetWt: 0
            })
          );
          updatedData.SetSizes = [...prevData.SetSizes, ...additionalRows];
        } else if (partValue < prevData.SetSizes.length) {
          // Remove rows if Part is smaller
          updatedData.SetSizes = prevData.SetSizes.slice(0, partValue);
        }

        return updatedData;
      });
    } else if (inputName === 'SetStatus' && value === 'Single') {
      // Automatically set Part to '1' if SetStatus is 'Single'
      setData5(prevData => ({
        ...prevData,
        SetStatus: value,
        Part: '1',
        SetSizes: [
          {
            SizeUnit: 'inch',
            SetRate: 0,
            Length: 0,
            Width: 0,
            Height: 0,
            cbm: 0,
            Description: '',
            ColorName: '',
            ColorCode: '',
            FinishName: '',
            FinishCode: '',
            NetWt: 0,
            MatName: ''
          }
        ]
      }));
    } else {
      setData5({ ...data5, [inputName]: updatedValue });
    }
  };

  const deleteMaterial = index => {
    setData5(prevData => {
      const updatedMaterials = [...prevData.ProductionDetail];
      updatedMaterials.splice(index, 1);
      return {
        ...prevData,
        ProductionDetail: updatedMaterials
      };
    });
  };

  const [userDetails, setUserDetails] = useState(false);
  const userName = localStorage.getItem('id');

  useEffect(() => {
    fetchUserName(); // Calling the async function
  }, []);
  const fetchUserName = async () => {
    try {
      const response = await fetch(
        `${ip}/api/user-details?populate=*&filters[id][$eq]=${userName}`
      );
      const res = await response.json();
      setUserDetails(res.data[0]?.attributes?.Authorised);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };
  const [num, setNum] = useState(0);
  const [num1, setNum1] = useState(0);
  const [name, setName] = useState('');
  const [data51, setData51] = useState(null);
  const [dataimg, setDataimg] = useState([]);
  const [multimg, setMultiImages] = useState<any>([]);
  const [multiImgScroll, setMultiImgScroll] = useState([]);
  const dataLength = multimg.data ? multimg.data.length : 0;

  // console.log("Scroll Images :", multiImgScroll)
  const handleUploadChange = files => {
    // Extract File objects from dataimg array
    const uploadedFiles = files.map(file => file.blobFile);

    // Filter out non-jpg/jpeg files
    const validImages = uploadedFiles.filter(file => {
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
      return allowedExtensions.includes(fileExtension);
    });

    // Display messages for each file
    if (validImages.length > 0) {
      toaster.push(<Message type="success">Files uploaded successfully</Message>);
    }

    const invalidImages = uploadedFiles.filter(file => !validImages.includes(file));
    invalidImages.forEach(file => {
      toaster.push(<Message type="error">{file.name} is not a valid jpg/jpeg file</Message>);
    });

    setDataimg(prevImages => [...prevImages, ...validImages]);
  };

  // Delete Data from API Start

  const [data123, setData123] = useState<RowData[]>([]);
  useEffect(() => {
    fetchData123();
  }, []);

  const fetchData123 = async () => {
    const response = await fetch(`${ip}/api/products?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/products?populate=*&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setData123(allData);
  };

  useEffect(() => {
    fetchData1234();
  }, []);

  const fetchData1234 = async () => {
    const response = await fetch(`${ip}/api/variant-products?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/variant-products?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    // console.log('allData-->', allData);
    setData1234(allData);
  };
  const saveWithVariants = () => {
    // Create a copy of the data5 object
    const originalData = { ...data5 };

    // Make changes for the variants
    // For example, change the color
    originalData.ColorCode = 'newColorCode';
    originalData.ColorName = 'newColorName';
    originalData.ProductId = 'newColorName';

    // You can similarly modify other properties based on your requirements

    // Create a copy of the formData for the original data
    const originalFormData = new FormData();

    // Add the original data to the formData
    originalFormData.append('files.CoverImage', originalData.CoverImage);
    originalFormData.append('files.MultipleImage', originalData.MultipleImage);

    originalData.MaterialCollection.forEach((collection, index) => {
      originalFormData.append(
        `data.MaterialCollection[${index + 1}].ProductCode`,
        originalData.ProductCode
      );
      originalFormData.append(
        `data.MaterialCollection[${index}].MatCollectionNm`,
        collection.MatCollectionNm
      );
      originalFormData.append(
        `data.MaterialCollection[${index}].MatCollectionCode`,
        collection.MatCollectionCode
      );
    });

    if (originalData.ProductionDetail.length > 0) {
      originalData.ProductionDetail[0].ProductCode = originalData.ProductCode;
    }

    originalData.ProductionDetail.forEach((material, index) => {
      originalFormData.append(
        `ProductionDetail[${index + 1}][ProductCode]`,
        originalData.ProductCode
      );
      originalFormData.append(`ProductionDetail[${index}][MaterialNm]`, material.MaterialNm);
      originalFormData.append(
        `ProductionDetail[${index}][MaterialFinishNm]`,
        material.MaterialFinishNm
      );
      originalFormData.append(
        `ProductionDetail[${index}][MatNetWeight]`,
        String(material.MatNetWeight)
      );
      originalFormData.append(`ProductionDetail[${index}][MaterialCode]`, material.MaterialCode);
      originalFormData.append(
        `ProductionDetail[${index}][MaterialFinishCode]`,
        material.MaterialFinishCode
      );
    });

    originalFormData.append(
      'data',
      JSON.stringify({
        ...originalData
        // Include any other changes made for the variants here
      })
    );

    // Send the original data to your API
    fetch(url2, {
      method: 'POST',
      body: originalFormData
    })
      .then(response => response.json())
      .then(data => {
        toaster.push(
          <Message showIcon type="success">
            Saved Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch(error => console.error(error));

    // Now, you can save the originalData object as a copy with variants
    // You can either store it in a separate state variable or use it as needed
  };
  const [compndata, setCompndata] = useState([]);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setAliasauto(json.data[0].attributes.AliasShort);
      setCompndata(json.data);
      setAuth(json.data[0].attributes.Authorised);
      setFinShow(json.data[0].attributes.setFinish);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [isLoading1, setIsLoading1] = useState(false); // Add the loading state
  const [singleImageDeleteId, setSingleImageDeleteId] = useState();
  const [MultipleImageDeleteIds, setMultipleImageDeleteIds] = useState();
  let nextCategoryCode1 = generateNextCategoryCode();

  //////// product fetch start ////////
  const url2 = `${ip}/api/products`;
  const url3 = `${ip}/api/variant-products`;
  const handleUpdateVariantData = async () => {
    setIsLoading1(true); // Start loading

    if (updateid === '' || updateid === null) {
      const dataCode = [...data123, ...data1234];
      if (
        dataCode.some(
          item =>
            item.attributes.ProductId.trim().toLowerCase() === data5.ProductId.trim().toLowerCase()
        ) &&
        (updateid === '' || updateid === null) &&
        data5.ProductId.trim() !== updateid.trim() // Ensure the product being updated is not causing the check
      ) {
        // Display an error message if alias code exists
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes?.AliasCode} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }
      nextCategoryCode1 = generateNextCategoryCode();
      const nextCategoryCode = nextCategoryCode1;
      const formData = new FormData();
      formData.append('files.CoverImage', data5.CoverImage);
      formData.append('files.threeDview', data5.threeDview);
      dataimg.forEach(image => {
        formData.append('files.MultipleImage', image);
      });
      data5.MaterialCollection.forEach((collection, index) => {
        formData.append(`data.MaterialCollection[${index + 1}].ProductCode`, nextCategoryCode);
        formData.append(
          `data.MaterialCollection[${index}].MatCollectionNm`,
          collection.MatCollectionNm
        );
        formData.append(
          `data.MaterialCollection[${index}].MatCollectionCode`,
          collection.MatCollectionCode
        );
      });
      data5.ProductionDetail.forEach((material, index) => {
        formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
        formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
        formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
      });

      const userName = localStorage.getItem('fullName');
      const cleanName = userName.replace(/\"/g, '');

      formData.append(
        'data',
        JSON.stringify({
          ...data5,
          CreatedBy: cleanName,
          ProductCode: nextCategoryCode, // Include ColorCode in formData
          Variant_Id: nextCategoryCode,
          Total_CBM: totalcbm1,
          Total_CFT: totalcft,
          TwentyFT: String(feet20),
          FortyFT: String(feet40),
          FortyHQ: String(feet20hc),
          Variant: variantImageChanged === true ? 'true' : 'false'
        })
      );
      fetch(url3, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // console.log(data);
          onChange1();
          setIsLoading1(false);
          // Refresh page after 2 seconds (2000 milliseconds)
        })
        .catch(error => {
          console.error(error);
          alert('Something went wrong. Please try again');
          setIsLoading1(false); // Stop loading on error
        });

      handleSaveVariantData();
      categoryCodeCounter++;
    } else {
      const updateUrl = `${url3}/${updateid}`;
      if (num == 1 && num1 == 1) {
        nextCategoryCode1 = generateNextCategoryCode();
        const nextCategoryCode = nextCategoryCode1;
        const formData = new FormData();

        // Append video files
        formData.append('files.CoverImage', data5.CoverImage);
        formData.append('files.threeDview', data5.threeDview);

        // Append multiple images
        dataimg.forEach(image => {
          formData.append('files.MultipleImage', image);
        });
        // Append MaterialCollection data
        data5.MaterialCollection.forEach((collection, index) => {
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionNm`,
            collection.MatCollectionNm
          );
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionCode`,
            collection.MatCollectionCode
          );
        });
        data5.ProductionDetail.forEach((material, index) => {
          formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
          formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
          formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
        });
        formData.append(
          'data',
          JSON.stringify({
            ...data5,
            Total_CBM: totalcbm1,
            Total_CFT: totalcft,
            TwentyFT: String(feet20),
            FortyFT: String(feet40),
            FortyHQ: String(feet20hc),
            Variant: varStatus
          })
        );
        fetch(updateUrl, {
          method: 'PUT',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log('-------1', data);
            onChange2();
            // Refresh page after 2 seconds (2000 milliseconds)
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
            setIsLoading1(false); // Stop loading on error
          }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });

        handleSaveVariantData();
      } else if (num == 1 && num1 == 0) {
        nextCategoryCode1 = generateNextCategoryCode();
        const nextCategoryCode = nextCategoryCode1;
        // const data = await axios.delete(`${ip}/api/upload/files/${singleImageDeleteId}`);

        const formData = new FormData();
        formData.append('files.CoverImage', data5.CoverImage);
        formData.append('files.threeDview', data5.threeDview);
        delete data5.MultipleImage,
          // dataimg.forEach((image) => {
          //   formData.append('files.MultipleImage', image);
          // });
          data5.MaterialCollection.forEach((collection, index) => {
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionNm`,
              collection.MatCollectionNm
            );
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionCode`,
              collection.MatCollectionCode
            );
          });
        data5.ProductionDetail.forEach((material, index) => {
          formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
          formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
          formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
        });
        formData.append(
          'data',
          JSON.stringify({
            ...data5,
            ProductId: data5.ProductId.trim(),
            Total_CBM: totalcbm1,
            Total_CFT: totalcft,
            TwentyFT: String(feet20),
            FortyFT: String(feet40),
            FortyHQ: String(feet20hc),
            Variant: varStatus
          })
        );

        fetch(updateUrl, {
          method: 'PUT',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log('data--------------2', data);
            onChange2();
            // Refresh page after 2 seconds (2000 milliseconds)
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
            setIsLoading1(false); // Stop loading on error
          }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });

        handleSaveVariantData();
      } else if (num == 0 && num1 == 1) {
        // MultipleImageDeleteIds && MultipleImageDeleteIds?.map(async (i) => {
        //   const data = await axios.delete(`${ip}/api/upload/files/${i}`);
        // });

        nextCategoryCode1 = generateNextCategoryCode();
        const nextCategoryCode = nextCategoryCode1;
        const formData = new FormData();
        // formData.append('files.CoverImage', data5.CoverImage);
        formData.append('files.threeDview', data5.threeDview);
        delete data5.CoverImage;
        dataimg.forEach(image => {
          formData.append('files.MultipleImage', image);
        });
        data5.MaterialCollection.forEach((collection, index) => {
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionNm`,
            collection.MatCollectionNm
          );
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionCode`,
            collection.MatCollectionCode
          );
        });
        data5.ProductionDetail.forEach((material, index) => {
          formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
          formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
          formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
        });
        formData.append(
          'data',
          JSON.stringify({
            ...data5,
            Total_CBM: totalcbm1,
            Total_CFT: totalcft,
            TwentyFT: String(feet20),
            FortyFT: String(feet40),
            FortyHQ: String(feet20hc),
            Variant: varStatus
          })
        );

        fetch(updateUrl, {
          method: 'PUT',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log('data---------3', data);
            onChange2();
            // Refresh page after 2 seconds (2000 milliseconds)
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
            setIsLoading1(false); // Stop loading on error
          }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });

        handleSaveVariantData();
      } else {
        const updatedCategory = {
          ...data5,
          Total_CBM: totalcbm1,
          Total_CFT: totalcft,
          TwentyFT: String(feet20),
          FortyFT: String(feet40),
          FortyHQ: String(feet20hc),
          Variant: varStatus
          // You might want to update only specific fields if needed
        };
        delete updatedCategory.MultipleImage;
        delete updatedCategory.CoverImage;
        fetch(updateUrl, {
          method: 'PUT', // Use PUT for updating
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ data: updatedCategory })
        })
          .then(response => response.json())
          .then(data => {
            // console.log('data-------------4', data);
            onChange2();
          })
          .catch(error => {
            console.error(error);
          }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });
        handleSaveVariantData();
      }
    }
  };

  const handleClicktrain = () => {
    const formDataArray = true;
    // console.log('Train data: ', formDataArray);
    const dataToSend = {
      formDataArray: formDataArray
    };

    fetch(`http://${hostname}${Port.smartsearchip}/api/train`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dataToSend)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json(); // Parse JSON response
      })
      .then(data => {
        console.log('Received data:', data);
      })
      .catch(error => {
        console.error('Error sending data:', error);
        // Optionally handle errors
      });
  };

  const fetchData = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`);
      const json = await response.json();
      // setDownloadAllImg(json.data[0].attributes.DownloadAllImage ?? false);

      // Set the authorization requirement from API
      setAuth(json.data[0].attributes.Authorised ?? false);
    } catch (err) {
      console.error("Error:", err);
    }
  };
  const [isFinalStepLoading, setIsFinalStepLoading] = useState(false)
  const submitStep0 = async e => {
    e.preventDefault()
    const { data: prcode } = await axios.get(`${globalIP}/api/products?populate=*`);
    const nextCode = prcode.meta.pagination.total + 1;
    if (data5.CategoryCode == '') {
      toaster.push(
        <Message showIcon type="error">
          Please add atleast one Product.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (data5.CoverImage == null) {
      toaster.push(
        <Message showIcon type="error">
          Please add atleast one Product Image.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (data5.ProductName == '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Product Name.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      e.preventDefault();
      if (updateid === '' || updateid === null) {
        const dataCode = [...data123, ...data1234];
        if (
          dataCode.some(
            item =>
              item.attributes.ProductId?.trim().toLowerCase() ===
              data5.ProductId?.trim().toLowerCase()
          ) &&
          (updateid === '' || updateid === null) &&
          data5.ProductId.trim() !== updateid.trim() // Ensure the product being updated is not causing the check
        ) {
          // Display an error message if alias code exists
          toaster.push(
            <Message showIcon type="error">
              {label[0]?.attributes?.AliasCode} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Stop further execution
        } else if (!/^[a-zA-Z0-9\-,]+$/.test(data5.ProductId.trim())) {
          toaster.push(
            <Message showIcon type="error">
              {label[0]?.attributes?.AliasCode} should not contain special characters.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Stop further execution
        }
        setIsLoading1(true); // Start loading
        const formData = new FormData();
        formData.append('files.CoverImage', data5.CoverImage);
        // console.log('data5.CoverImage', data5.CoverImage);
        formData.append('files.threeDview', data5.threeDview);
        // console.log('updated image', dataimg)
        dataimg.forEach(image => {
          formData.append('files.MultipleImage', image);
        });
        // formData.append('files.MultipleImage', data5.MultipleImage);
        // data5.MultipleImage.forEach((file, index) => {
        // formData.append(`files.MultipleImage[${index}]`, file.blobFile);
        // });
        data5.MaterialCollection.forEach((collection, index) => {
          formData.append(
            `data.MaterialCollection[${index + 1}].ProductCode`,
            `PRD-${nextCode.toString().padStart(3, '0')}`
          );
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionNm`,
            collection.MatCollectionNm
          );
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionCode`,
            collection.MatCollectionCode
          );
        });
        // if (data5.ProductionDetail.length > 0) {
        //   data5.ProductionDetail[0].ProductCode = data5.ProductCode;
        // }
        data5.ProductionDetail.forEach((material, index) => {
          formData.append(
            `data.ProductionDetail[${index + 1}].ProductCode`,
            `PRD-${nextCode.toString().padStart(3, '0')}`
          );
          formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
          formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          // formData.append(`ProductionDetail[${index}][MaterialFinishNm]`, material.MaterialFinishNm);
          // formData.append(`ProductionDetail[${index}][MatNetWeight]`, String(material.MatNetWeight));
          // formData.append(`ProductionDetail[${index}][MaterialFinishCode]`, material.MaterialFinishCode);
        });

        // const userName = localStorage.getItem('fullName');
        // const cleanName = userName.replace(/\"/g, '');

        // let authorizedStatus;
        // let authorizedBy;
        // let authDate;
        // if (!auth) {
        //   authorizedStatus = 'Authorised';
        // } else {
        //   authorizedStatus = userDetails ? 'Authorised' : 'Pending';
        //   authorizedBy = userDetails ? cleanName : '';
        //   authDate = userDetails ? new Date().toISOString() : null;
        // }
        // formData.append(
        //   'data',
        //   JSON.stringify({
        //     ...data5,
        //     ProductId: data5.ProductId.trim(),
        //     CreatedBy: cleanName,
        //     MOQ: data5.MOQ.toString(),
        //     ProductCode: `PRD-${nextCode.toString().padStart(3, '0')}`, // Include ColorCode in formData
        //     Variant_Id: `PRD-${nextCode.toString().padStart(3, '0')}`,
        //     Total_CBM: totalcbm1,
        //     Total_CFT: totalcft,
        //     TwentyFT: String(feet20),
        //     FortyFT: String(feet40),
        //     FortyHQ: String(feet20hc),
        //     Variant: variantImageChanged === true ? 'true' : 'false',
        //     Authorized: authorizedStatus,
        //     AuthorisedBy: cleanName,
        //     AuthDate: authDate
        //   })
        // );

        const userData = JSON.parse(localStorage.getItem('udata') || '{}');
        const role = userData?.Category; // "Admin" or "Staff"
        const fullName = userData?.Full_Name || '';
        const userName = localStorage.getItem('fullName');
        const cleanName = userName ? userName.replace(/\"/g, '') : fullName;

        // Authorization logic
        let authorizedStatus;
        let authorizedBy;
        let authDate;

        if (!auth) {
          // If authorization is not required by company settings
          authorizedStatus = 'Authorised';
          authorizedBy = cleanName;
          authDate = new Date().toISOString();
        } else {
          // If authorization is required by company settings
          if (role === 'Admin') {
            // Admin can auto-authorize
            authorizedStatus = 'Authorised';
            authorizedBy = cleanName;
            authDate = new Date().toISOString();
          } else {
            // Staff or other roles need approval
            authorizedStatus = 'Pending';
            authorizedBy = '';
            authDate = null;
          }
        }

        // Prepare the data object
        const dataToSubmit = {
          ...data5,
          ProductId: data5.ProductId.trim(),
          CreatedBy: cleanName,
          MOQ: data5.MOQ.toString(),
          ProductCode: `PRD-${nextCode.toString().padStart(3, '0')}`,
          Variant_Id: `PRD-${nextCode.toString().padStart(3, '0')}`,
          Total_CBM: totalcbm1,
          Total_CFT: totalcft,
          TwentyFT: String(feet20),
          FortyFT: String(feet40),
          FortyHQ: String(feet20hc),
          Variant: variantImageChanged === true ? 'true' : 'false',
          Authorized: authorizedStatus,
          AuthorisedBy: authorizedBy,
          AuthDate: authDate
        };

        formData.append('data', JSON.stringify(dataToSubmit));
        fetch(url2, {
          method: 'POST',
          body: formData,
          credentials: 'omit'
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            setIsLoading1(false);
            if (!(e.ctrlKey || e.metaKey)) {
              onChange1();
              window.location.reload();
            }
            // Refresh page after 2 seconds (2000 milliseconds)
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
            setIsLoading1(false); // Stop loading on error
          });

        handleSaveVariantData();
      } else {
        let updateUrl = `${url2}/${updateid}`;
        if (svarid) {
          updateUrl = `${url3}/${svarid}`;
        }
        if (num == 1 && num1 == 1) {
          nextCategoryCode1 = generateNextCategoryCode();
          const nextCategoryCode = nextCategoryCode1;
          const formData = new FormData();

          if (typeof data5.CoverImage !== 'string' && data5.CoverImage !== null) {
            formData.append('files.CoverImage', data5.CoverImage);
          }

          if (typeof data5.threeDview !== 'string' && data5.threeDview !== null) {
            formData.append('files.threeDview', data5.threeDview);
          }

          await fetch(updateUrl, {
            method: 'PUT',
            body: JSON.stringify({
              data: {
                MultipleImage: null
              }
            })
          });
          console.log('dataimg in add product', dataimg);
          // Append multiple images
          dataimg.forEach(image => {
            formData.append('files.MultipleImage', image);
          });
          const filteredData = { ...data5 };
          // if (!data5.threeDview || typeof data5.threeDview === 'string') {
          //   delete filteredData.threeDview;
          // }
          // Append MaterialCollection data
          data5.MaterialCollection.forEach((collection, index) => {
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionNm`,
              collection.MatCollectionNm
            );
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionCode`,
              collection.MatCollectionCode
            );
          });
          data5.ProductionDetail.forEach((material, index) => {
            formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
            formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
            formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          });
          const { CoverImage, threeDview, ...etcData5 } = data5;
          formData.append(
            'data',
            JSON.stringify({
              ...etcData5,
              Total_CBM: totalcbm1,
              Total_CFT: totalcft,
              TwentyFT: String(feet20),
              FortyFT: String(feet40),
              FortyHQ: String(feet20hc),
              Variant: varStatus
            })
          );
          fetch(updateUrl, {
            method: 'PUT',
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              // console.log('-------1', data);
              onChange2();
              // Refresh page after 2 seconds (2000 milliseconds)
            })
            .catch(error => {
              console.error(error);
              alert('Something went wrong. Please try again');
              setIsLoading1(false); // Stop loading on error
            });

          handleSaveVariantData();
        } else if (num == 1 && num1 == 0) {
          nextCategoryCode1 = generateNextCategoryCode();
          const nextCategoryCode = nextCategoryCode1;
          // const data = await axios.delete(`${ip}/api/upload/files/${singleImageDeleteId}`);

          const formData = new FormData();
          if (typeof data5.CoverImage !== 'string' && data5.CoverImage !== null) {
            formData.append('files.CoverImage', data5.CoverImage);
          }

          if (typeof data5.threeDview !== 'string' && data5.threeDview !== null) {
            formData.append('files.threeDview', data5.threeDview);
          }

          delete data5.MultipleImage,
            // dataimg.forEach((image) => {
            //   formData.append('files.MultipleImage', image);
            // });
            data5.MaterialCollection.forEach((collection, index) => {
              formData.append(
                `data.MaterialCollection[${index}].MatCollectionNm`,
                collection.MatCollectionNm
              );
              formData.append(
                `data.MaterialCollection[${index}].MatCollectionCode`,
                collection.MatCollectionCode
              );
            });
          data5.ProductionDetail.forEach((material, index) => {
            formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
            formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
            formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          });
          const { CoverImage, threeDview, ...etcData5 } = data5;
          formData.append(
            'data',
            JSON.stringify({
              ...etcData5,
              ProductId: data5.ProductId.trim(),
              Total_CBM: totalcbm1,
              Total_CFT: totalcft,
              TwentyFT: String(feet20),
              FortyFT: String(feet40),
              FortyHQ: String(feet20hc),
              Variant: varStatus
            })
          );

          fetch(updateUrl, {
            method: 'PUT',
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              // console.log('data--------------2', data);
              onChange2();

              // Refresh page after 2 seconds (2000 milliseconds)
            })
            .catch(error => {
              console.error(error);
              alert('Something went wrong. Please try again');
              setIsLoading1(false); // Stop loading on error
            });

          handleSaveVariantData();
        } else if (num == 0 && num1 == 1) {
          // MultipleImageDeleteIds && MultipleImageDeleteIds?.map(async (i) => {
          //   const data = await axios.delete(`${ip}/api/upload/files/${i}`);
          // });

          nextCategoryCode1 = generateNextCategoryCode();
          const nextCategoryCode = nextCategoryCode1;
          const formData = new FormData();
          // formData.append('files.CoverImage', data5.CoverImage);
          if (typeof data5.CoverImage !== 'string' && data5.CoverImage !== null) {
            formData.append('files.CoverImage', data5.CoverImage);
          }

          if (typeof data5.threeDview !== 'string' && data5.threeDview !== null) {
            formData.append('files.threeDview', data5.threeDview);
          }

          dataimg.forEach(image => {
            formData.append('files.MultipleImage', image);
          });
          data5.MaterialCollection.forEach((collection, index) => {
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionNm`,
              collection.MatCollectionNm
            );
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionCode`,
              collection.MatCollectionCode
            );
          });
          data5.ProductionDetail.forEach((material, index) => {
            formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
            formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
            formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          });
          const { CoverImage, threeDview, ...etcData5 } = data5;
          formData.append(
            'data',
            JSON.stringify({
              ...etcData5,
              Total_CBM: totalcbm1,
              Total_CFT: totalcft,
              TwentyFT: String(feet20),
              FortyFT: String(feet40),
              FortyHQ: String(feet20hc),
              Variant: varStatus
            })
          );

          fetch(updateUrl, {
            method: 'PUT',
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              // console.log('data---------3', data);
              onChange2();
              // Refresh page after 2 seconds (2000 milliseconds)
            })
            .catch(error => {
              console.error(error);
              alert('Something went wrong. Please try again');
              setIsLoading1(false); // Stop loading on error
            });

          handleSaveVariantData();
        } else {
          const updatedCategory = {
            ...data5,
            Total_CBM: totalcbm1,
            Total_CFT: totalcft,
            TwentyFT: String(feet20),
            FortyFT: String(feet40),
            FortyHQ: String(feet20hc),
            Variant: varStatus
            // You might want to update only specific fields if needed
          };
          delete updatedCategory.MultipleImage;
          delete updatedCategory.CoverImage;
          fetch(updateUrl, {
            method: 'PUT', // Use PUT for updating
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ data: updatedCategory })
          })
            .then(response => response.json())
            .then(data => {
              // console.log('data-------------4', data);
              onChange2();
            })
            .catch(error => {
              console.error(error);
            });
          handleSaveVariantData();
        }
      }
    }
    // if (svarid) {
    //   handleUpdateVariantData();
    // }
  };
  // console.log("Submitting data5:", data5);

  // const submitStep0 = async e => {
  //   e.preventDefault();
  //   setIsFinalStepLoading(true);
  //   setIsLoading1(true);

  //   // Validation for Step 0
  //   if (!data5.CategoryCode) {
  //     toaster.push(<Message showIcon type="error">Please add at least one Product.</Message>, { placement: 'topCenter' });
  //     setIsFinalStepLoading(false);
  //     setIsLoading1(false);
  //     return;
  //   }
  //   if (!data5.CoverImage) {
  //     toaster.push(<Message showIcon type="error">Please add at least one Product Image.</Message>, { placement: 'topCenter' });
  //     setIsFinalStepLoading(false);
  //     setIsLoading1(false);
  //     return;
  //   }
  //   if (!data5.ProductName) {
  //     toaster.push(<Message showIcon type="error">Please Enter Product Name.</Message>, { placement: 'topCenter' });
  //     setIsFinalStepLoading(false);
  //     setIsLoading1(false);
  //     return;
  //   }

  //   try {
  //     const userData = JSON.parse(localStorage.getItem('udata') || '{}');
  //     const fullName = (localStorage.getItem('fullName') || userData?.Full_Name || '').replace(/\"/g, '');

  //     // Only include Step 0 fields
  //     const dataToSubmit = {
  //       ProductId: data5.ProductId.trim(),
  //       ProductName: data5.ProductName,
  //       Description: data5.Description,
  //       CategoryCode: data5.CategoryCode,
  //       ProductTypeCode: data5.ProductTypeCode,
  //       FinishCode: data5.FinishCode,
  //       ColorCode: data5.ColorCode,
  //       SizeUnit: data5.SizeUnit,
  //       Length: data5.Length,
  //       Width: data5.Width,
  //       Height: data5.Height,
  //       NetWeight: data5.NetWeight,
  //       GrossWeight: data5.GrossWeight,
  //       HSNCode: data5.HSNCode,
  //       SellingPriceCurrency: data5.SellingPriceCurrency,
  //       SellingPriceUnit: data5.SellingPriceUnit,
  //       SellingPrice: data5.SellingPrice,
  //       ProductCost: data5.ProductCost,
  //       SearchKeyword: data5.SearchKeyword,
  //       MOQ: data5.MOQ,
  //       ProductDesigner: data5.ProductDesigner,
  //       MadeBy: data5.MadeBy,
  //       CategoryName: data5.CategoryName,
  //       ProductTypeName: data5.ProductTypeName,
  //       Shape: data5.Shape,
  //       Season: data5.Season,
  //       P_Technique: data5.P_Technique,
  //       FinishName: data5.FinishName,
  //       ColorName: data5.ColorName,
  //       BuyerName: data5.BuyerName,
  //       BuyerSku: data5.BuyerSku,
  //       SizeRange: data5.SizeRange,
  //       Product_Remark: data5.Product_Remark,
  //       Buyer_Remark: data5.Buyer_Remark,
  //       // L: data5.L,
  //       // M: data5.M,
  //       // MX: data5.MX,
  //       // Variant: varStatus,
  //       // Total_CBM: totalcbm1,
  //       // Total_CFT: totalcft,
  //       // TwentyFT: String(feet20),
  //       // FortyFT: String(feet40),
  //       // FortyHQ: String(feet20hc),
  //       CoverImage: data5.CoverImage,
  //       threeDview: data5.threeDview,
  //       MaterialCollection: data5.MaterialCollection?.map(item => ({
  //         ProductCode: item.ProductCode,       // Keep ProductCode
  //         MatCollectionNm: item.MatCollectionNm,
  //         MatCollectionCode: item.MatCollectionCode
  //       })),
  //       ProductionDetail: data5.ProductionDetail?.map(item => ({
  //         ProductCode: item.ProductCode,       // Keep ProductCode
  //         MaterialNm: item.MaterialNm,
  //         MaterialFinishNm: item.MaterialFinishNm,
  //         MatNetWeight: item.MatNetWeight,
  //         MaterialCode: item.MaterialCode,
  //         MaterialFinishCode: item.MaterialFinishCode,
  //         Component: item.Component,
  //         Unit: item.Unit,
  //         Length: item.Length,
  //         Width: item.Width,
  //         Height: item.Height,
  //         Depth: item.Depth,
  //         Qty: item.Qty,
  //         Remark: item.Remark
  //       }))
  //     };

  //     const formData = new FormData();
  //     if (data5.CoverImage && typeof data5.CoverImage !== 'string') formData.append('files.CoverImage', data5.CoverImage);
  //     dataimg.forEach(img => formData.append('files.MultipleImage', img));
  //     formData.append('data', JSON.stringify(dataToSubmit));

  //     const url = updateid ? `${url2}/${updateid}` : url2;
  //     const method = updateid ? 'PUT' : 'POST';

  //     const response = await fetch(url, { method, body: formData });
  //     const result = await response.json();
  //     console.log('Step 0 submit result:', result);

  //     toaster.push(<Message showIcon type="success">Product saved successfully!</Message>, { placement: 'topCenter' });

  //     setIsLoading1(false);
  //     setIsFinalStepLoading(false);

  //     // Optionally refresh table data
  //     onChange2();

  //   } catch (err) {
  //     console.error(err);
  //     toaster.push(<Message showIcon type="error">Something went wrong. Please try again.</Message>, { placement: 'topCenter' });
  //     setIsLoading1(false);
  //     setIsFinalStepLoading(false);
  //   }
  // };
  const submit = async e => {
    e.preventDefault();

    setIsFinalStepLoading(true)
    const { data: prcode } = await axios.get(`${globalIP}/api/products?populate=*`);
    const nextCode = prcode.meta.pagination.total + 1;
    if (data5.CategoryCode == '') {
      toaster.push(
        <Message showIcon type="error">
          Please add atleast one Product.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (data5.CoverImage == null) {
      toaster.push(
        <Message showIcon type="error">
          Please add atleast one Product Image.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (data5.ProductName == '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Product Name.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      e.preventDefault();
      if (updateid === '' || updateid === null) {
        const dataCode = [...data123, ...data1234];
        if (
          dataCode.some(
            item =>
              item.attributes.ProductId?.trim().toLowerCase() ===
              data5.ProductId?.trim().toLowerCase()
          ) &&
          (updateid === '' || updateid === null) &&
          data5.ProductId.trim() !== updateid.trim() // Ensure the product being updated is not causing the check
        ) {
          // Display an error message if alias code exists
          toaster.push(
            <Message showIcon type="error">
              {label[0]?.attributes?.AliasCode} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Stop further execution
        } else if (!/^[a-zA-Z0-9\-,]+$/.test(data5.ProductId.trim())) {
          toaster.push(
            <Message showIcon type="error">
              {label[0]?.attributes?.AliasCode} should not contain special characters.
            </Message>,
            { placement: 'topCenter' }
          );
          return; // Stop further execution
        }
        setIsLoading1(true); // Start loading
        const formData = new FormData();
        formData.append('files.CoverImage', data5.CoverImage);
        // console.log('data5.CoverImage', data5.CoverImage);
        formData.append('files.threeDview', data5.threeDview);
        // console.log('updated image', dataimg)
        dataimg.forEach(image => {
          formData.append('files.MultipleImage', image);
        });
        // formData.append('files.MultipleImage', data5.MultipleImage);
        // data5.MultipleImage.forEach((file, index) => {
        // formData.append(`files.MultipleImage[${index}]`, file.blobFile);
        // });
        data5.MaterialCollection.forEach((collection, index) => {
          formData.append(
            `data.MaterialCollection[${index + 1}].ProductCode`,
            `PRD-${nextCode.toString().padStart(3, '0')}`
          );
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionNm`,
            collection.MatCollectionNm
          );
          formData.append(
            `data.MaterialCollection[${index}].MatCollectionCode`,
            collection.MatCollectionCode
          );
        });
        // if (data5.ProductionDetail.length > 0) {
        //   data5.ProductionDetail[0].ProductCode = data5.ProductCode;
        // }
        data5.ProductionDetail.forEach((material, index) => {
          formData.append(
            `data.ProductionDetail[${index + 1}].ProductCode`,
            `PRD-${nextCode.toString().padStart(3, '0')}`
          );
          formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
          formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          // formData.append(`ProductionDetail[${index}][MaterialFinishNm]`, material.MaterialFinishNm);
          // formData.append(`ProductionDetail[${index}][MatNetWeight]`, String(material.MatNetWeight));
          // formData.append(`ProductionDetail[${index}][MaterialFinishCode]`, material.MaterialFinishCode);
        });

        // const userName = localStorage.getItem('fullName');
        // const cleanName = userName.replace(/\"/g, '');

        // let authorizedStatus;
        // let authorizedBy;
        // let authDate;
        // if (!auth) {
        //   authorizedStatus = 'Authorised';
        // } else {
        //   authorizedStatus = userDetails ? 'Authorised' : 'Pending';
        //   authorizedBy = userDetails ? cleanName : '';
        //   authDate = userDetails ? new Date().toISOString() : null;
        // }
        // formData.append(
        //   'data',
        //   JSON.stringify({
        //     ...data5,
        //     ProductId: data5.ProductId.trim(),
        //     CreatedBy: cleanName,
        //     MOQ: data5.MOQ.toString(),
        //     ProductCode: `PRD-${nextCode.toString().padStart(3, '0')}`, // Include ColorCode in formData
        //     Variant_Id: `PRD-${nextCode.toString().padStart(3, '0')}`,
        //     Total_CBM: totalcbm1,
        //     Total_CFT: totalcft,
        //     TwentyFT: String(feet20),
        //     FortyFT: String(feet40),
        //     FortyHQ: String(feet20hc),
        //     Variant: variantImageChanged === true ? 'true' : 'false',
        //     Authorized: authorizedStatus,
        //     AuthorisedBy: cleanName,
        //     AuthDate: authDate
        //   })
        // );

        const userData = JSON.parse(localStorage.getItem('udata') || '{}');
        const role = userData?.Category; // "Admin" or "Staff"
        const fullName = userData?.Full_Name || '';
        const userName = localStorage.getItem('fullName');
        const cleanName = userName ? userName.replace(/\"/g, '') : fullName;

        // Authorization logic
        let authorizedStatus;
        let authorizedBy;
        let authDate;

        if (!auth) {
          // If authorization is not required by company settings
          authorizedStatus = 'Authorised';
          authorizedBy = cleanName;
          authDate = new Date().toISOString();
        } else {
          // If authorization is required by company settings
          if (role === 'Admin') {
            // Admin can auto-authorize
            authorizedStatus = 'Authorised';
            authorizedBy = cleanName;
            authDate = new Date().toISOString();
          } else {
            // Staff or other roles need approval
            authorizedStatus = 'Pending';
            authorizedBy = '';
            authDate = null;
          }
        }

        // Prepare the data object
        const dataToSubmit = {
          ...data5,
          ProductId: data5.ProductId.trim(),
          CreatedBy: cleanName,
          MOQ: data5.MOQ.toString(),
          ProductCode: `PRD-${nextCode.toString().padStart(3, '0')}`,
          Variant_Id: `PRD-${nextCode.toString().padStart(3, '0')}`,
          Total_CBM: totalcbm1,
          Total_CFT: totalcft,
          TwentyFT: String(feet20),
          FortyFT: String(feet40),
          FortyHQ: String(feet20hc),
          Variant: variantImageChanged === true ? 'true' : 'false',
          Authorized: authorizedStatus,
          AuthorisedBy: authorizedBy,
          AuthDate: authDate
        };

        formData.append('data', JSON.stringify(dataToSubmit));
        fetch(url2, {
          method: 'POST',
          body: formData,
          credentials: 'omit'
        })
          .then(response => response.json())
          .then(data => {
            setIsLoading1(false);
            if (!(e.ctrlKey || e.metaKey)) {
              onChange1();
              window.location.reload();
            }
            // Refresh page after 2 seconds (2000 milliseconds)
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
            setIsLoading1(false); // Stop loading on error
          });

        handleSaveVariantData();
      } else {
        let updateUrl = `${url2}/${updateid}`;
        if (svarid) {
          updateUrl = `${url3}/${svarid}`;
        }
        if (num == 1 && num1 == 1) {
          nextCategoryCode1 = generateNextCategoryCode();
          const nextCategoryCode = nextCategoryCode1;
          const formData = new FormData();

          if (typeof data5.CoverImage !== 'string' && data5.CoverImage !== null) {
            formData.append('files.CoverImage', data5.CoverImage);
          }

          if (typeof data5.threeDview !== 'string' && data5.threeDview !== null) {
            formData.append('files.threeDview', data5.threeDview);
          }

          await fetch(updateUrl, {
            method: 'PUT',
            body: JSON.stringify({
              data: {
                MultipleImage: null
              }
            })
          });
          console.log('dataimg in add product', dataimg);
          // Append multiple images
          dataimg.forEach(image => {
            formData.append('files.MultipleImage', image);
          });
          const filteredData = { ...data5 };
          // if (!data5.threeDview || typeof data5.threeDview === 'string') {
          //   delete filteredData.threeDview;
          // }
          // Append MaterialCollection data
          data5.MaterialCollection.forEach((collection, index) => {
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionNm`,
              collection.MatCollectionNm
            );
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionCode`,
              collection.MatCollectionCode
            );
          });
          data5.ProductionDetail.forEach((material, index) => {
            formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
            formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
            formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          });
          const { CoverImage, threeDview, ...etcData5 } = data5;
          formData.append(
            'data',
            JSON.stringify({
              ...etcData5,
              Total_CBM: totalcbm1,
              Total_CFT: totalcft,
              TwentyFT: String(feet20),
              FortyFT: String(feet40),
              FortyHQ: String(feet20hc),
              Variant: varStatus
            })
          );
          fetch(updateUrl, {
            method: 'PUT',
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              // history(`/${ugr}/products`)
              // console.log('-------1', data);
              onChange2();
              // Refresh page after 2 seconds (2000 milliseconds)
            })
            .catch(error => {
              console.error(error);
              alert('Something went wrong. Please try again');
              setIsLoading1(false); // Stop loading on error
            }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });

          handleSaveVariantData();
        } else if (num == 1 && num1 == 0) {
          nextCategoryCode1 = generateNextCategoryCode();
          const nextCategoryCode = nextCategoryCode1;
          // const data = await axios.delete(`${ip}/api/upload/files/${singleImageDeleteId}`);

          const formData = new FormData();
          if (typeof data5.CoverImage !== 'string' && data5.CoverImage !== null) {
            formData.append('files.CoverImage', data5.CoverImage);
          }

          if (typeof data5.threeDview !== 'string' && data5.threeDview !== null) {
            formData.append('files.threeDview', data5.threeDview);
          }

          delete data5.MultipleImage,
            // dataimg.forEach((image) => {
            //   formData.append('files.MultipleImage', image);
            // });
            data5.MaterialCollection.forEach((collection, index) => {
              formData.append(
                `data.MaterialCollection[${index}].MatCollectionNm`,
                collection.MatCollectionNm
              );
              formData.append(
                `data.MaterialCollection[${index}].MatCollectionCode`,
                collection.MatCollectionCode
              );
            });
          data5.ProductionDetail.forEach((material, index) => {
            formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
            formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
            formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          });
          const { CoverImage, threeDview, ...etcData5 } = data5;
          formData.append(
            'data',
            JSON.stringify({
              ...etcData5,
              ProductId: data5.ProductId.trim(),
              Total_CBM: totalcbm1,
              Total_CFT: totalcft,
              TwentyFT: String(feet20),
              FortyFT: String(feet40),
              FortyHQ: String(feet20hc),
              Variant: varStatus
            })
          );

          fetch(updateUrl, {
            method: 'PUT',
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              // console.log('data--------------2', data);
              onChange2();
              setIsFinalStepLoading(false)
              //** final step */
              // Refresh page after 2 seconds (2000 milliseconds)
            })
            .catch(error => {
              console.error(error);
              setIsFinalStepLoading(false)
              alert('Something went wrong. Please try again');
              setIsLoading1(false); // Stop loading on error
            }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });

          handleSaveVariantData();
        } else if (num == 0 && num1 == 1) {
          // MultipleImageDeleteIds && MultipleImageDeleteIds?.map(async (i) => {
          //   const data = await axios.delete(`${ip}/api/upload/files/${i}`);
          // });

          nextCategoryCode1 = generateNextCategoryCode();
          const nextCategoryCode = nextCategoryCode1;
          const formData = new FormData();
          // formData.append('files.CoverImage', data5.CoverImage);
          if (typeof data5.CoverImage !== 'string' && data5.CoverImage !== null) {
            formData.append('files.CoverImage', data5.CoverImage);
          }

          if (typeof data5.threeDview !== 'string' && data5.threeDview !== null) {
            formData.append('files.threeDview', data5.threeDview);
          }

          dataimg.forEach(image => {
            formData.append('files.MultipleImage', image);
          });
          data5.MaterialCollection.forEach((collection, index) => {
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionNm`,
              collection.MatCollectionNm
            );
            formData.append(
              `data.MaterialCollection[${index}].MatCollectionCode`,
              collection.MatCollectionCode
            );
          });
          data5.ProductionDetail.forEach((material, index) => {
            formData.append(`data.ProductionDetail[${index + 1}].ProductCode`, nextCategoryCode);
            formData.append(`data.ProductionDetail[${index}].MaterialNm`, material.MaterialNm);
            formData.append(`data.ProductionDetail[${index}].MaterialCode`, material.MaterialCode);
          });
          const { CoverImage, threeDview, ...etcData5 } = data5;
          formData.append(
            'data',
            JSON.stringify({
              ...etcData5,
              Total_CBM: totalcbm1,
              Total_CFT: totalcft,
              TwentyFT: String(feet20),
              FortyFT: String(feet40),
              FortyHQ: String(feet20hc),
              Variant: varStatus
            })
          );

          fetch(updateUrl, {
            method: 'PUT',
            body: formData
          })
            .then(response => response.json())
            .then(data => {
              // console.log('data---------3', data);
              onChange2();
              // Refresh page after 2 seconds (2000 milliseconds)
            })
            .catch(error => {
              console.error(error);
              alert('Something went wrong. Please try again');
              setIsLoading1(false); // Stop loading on error
            }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });

          handleSaveVariantData();
        } else {
          const updatedCategory = {
            ...data5,
            Total_CBM: totalcbm1,
            Total_CFT: totalcft,
            TwentyFT: String(feet20),
            FortyFT: String(feet40),
            FortyHQ: String(feet20hc),
            Variant: varStatus
            // You might want to update only specific fields if needed
          };
          delete updatedCategory.MultipleImage;
          delete updatedCategory.CoverImage;
          fetch(updateUrl, {
            method: 'PUT', // Use PUT for updating
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ data: updatedCategory })
          })
            .then(response => response.json())
            .then(data => {
              // console.log('data-------------4', data);
              onChange2();
            })
            .catch(error => {
              console.error(error);
            }).finally(() => { setIsVariantSubmitting(false); setNumVariants(null) });
          handleSaveVariantData();
        }
      }
    }
    // if (svarid) {
    //   handleUpdateVariantData();
    // }
  };

  //category data fetch start

  const [categorydata, setCategorydata] = useState([]);
  const [categorymeta, setCategorymeta] = useState<MetaData>();
  const [isLoadingc, setIsLoadingc] = useState(false);

  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc);
  }, [category]);
  //product type data fetch start
  const [productypedata, setProductypedata] = useState([]);

  const [isLoadingpro, setIsLoadingpro] = useState(false);

  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(setProductypedata, isLoadingpro, setIsLoadingpro, selectedCategoryCode);
    } else {
      setProductypedata([]);
    }
  }, [selectedCategoryCode]);
  // const handleAddColor = async (e) => {
  //   e.preventDefault();

  //   const created = await submit5(e);

  //   if (created?.data?.attributes?.ColorName) {
  //     const newColorName = created.data.attributes.ColorName;
  //     const newColorCode = created.data.attributes.ColorCode;

  //     // ✅ Refetch the colors first
  //     await fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);

  //     // ✅ Temporarily select the new color
  //     setSelectedColorName({
  //       ColorName: newColorName,
  //       ColorCode: newColorCode,
  //     });

  //     // ✅ Also update the main form data (so it stays consistent)
  //     handleInputChange("ColorName", newColorName, 0);

  //     // ✅ Clear input box for new color creation
  //     setColor({
  //       ColorCode: "",
  //       ColorName: "",
  //       dis: "Continue",
  //     });
  //   }
  // };

  const handleClick = async (e) => {
    e.preventDefault();

    // Call your existing submit2 function to add product type
    await submit2(e);

    // Then refetch product types for the selected category
    if (selectedCategoryCode) {
      await fetchProductTypes(
        setProductypedata,
        isLoadingpro,
        setIsLoadingpro,
        selectedCategoryCode
      );
    }
  };

  //product type data fetch end
  //Collection type data fetch start
  const [collectiondata, setCollectiondata] = React.useState([]);
  const [isLoadingcoll, setIsLoadingcoll] = React.useState(false);
  useEffect(() => {
    fetchMaterialCollection(setCollectiondata, isLoadingcoll, setIsLoadingcoll);
  }, [collection]);
  //Collection type data fetch end
  //Finish type data fetch start
  const [finishdata, setFinishData] = React.useState([]);
  const [isLoadingfin, setIsLoadingfin] = React.useState(false);

  const [currColorIndex, setCurrColorIndex] = useState(0);
  const [currFinishIndex, setCurrFinishIndex] = useState(0);
  useEffect(() => {
    if (color.ColorName == '') {
      handleUpdateItemCode('ColorName', currColorIndex);
    }
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, [color.ColorName]);
  useEffect(() => {
    if (finish.FinishName == '') {
      handleUpdateItemCode('FinishName', currFinishIndex);
    }
    fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin);
  }, [finish.FinishName]);
  const handleUpdateItemCode = async (field, index) => {
    const updatedDetails = [...data5.SetSizes];

    if (field === 'ColorName') {
      // Find the corresponding ColorCode from colordata
      const response = await fetch(
        `${ip}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue&sort[0]=ColorName&filters[ColorName]=${updatedDetails[index].ColorName}`
      );
      const json = await response.json();
      const selectedColorCode = json?.data[0]?.attributes?.ColorCode;
      updatedDetails[index] = {
        ...updatedDetails[index],
        ColorName: updatedDetails[index].ColorName,
        ColorCode: selectedColorCode // Set ColorCode or empty if not found
      };
    } else if (field === 'FinishName') {
      // Find the corresponding ColorCode from colordata
      const response = await fetch(
        `${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue&sort[0]=FinishName&filters[FinishName]=${updatedDetails[index].FinishName}`
      );
      const json = await response.json();
      const selectedFinishCode = json?.data[0]?.attributes?.FinishCode;
      updatedDetails[index] = {
        ...updatedDetails[index],
        FinishName: updatedDetails[index].FinishName,
        FinishCode: selectedFinishCode // Set ColorCode or empty if not found
      };
    }
    // console.log('updated :', updatedDetails);

    setData5(prevData => {
      return {
        ...prevData,
        SetSizes: updatedDetails
      };
    });
  };
  //Finish type data fetch end
  //color type data fetch start
  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  //color type data fetch end
  //hsn type data fetch start
  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    // console.log('hsndata', hsndata);
  }, [hsndata]);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, [hscode]);
  //hsn type data fetch end
  //material type data fetch start
  const [materialdata, setMaterialdata] = useState([]);
  const [isLoadingmat, setIsLoadingmat] = useState(false);
  useEffect(() => {
    let params =
      '&filters[Type][$eq]=mrmaterial&filters[Type][$eq]=cmaterial&filters[Type][$eq]=wmaterial';
    fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat, params);
  }, []);
  //material type data fetch end
  //component type data fetch start
  const [compdata, setCompdata] = useState([]);
  const [isLoadingcomp, setIsLoadingcomp] = useState(false);
  useEffect(() => {
    fetchComponent(setCompdata, isLoadingcomp, setIsLoadingcomp);
  }, []);
  //component type data fetch end

  //shape data fetch start
  const [shapedata, setShapedata] = useState([]);
  const [isLoadingshape, setIsLoadingshape] = useState(false);
  useEffect(() => {
    fetchShape(setShapedata, isLoadingshape, setIsLoadingshape);
  }, [shape]);
  //shape data fetch end
  //season data fetch start
  const [seasondata, setSeasondata] = useState([]);
  const [isLoadingseason, setIsLoadingseason] = useState(false);
  useEffect(() => {
    fetchSeason(setSeasondata, isLoadingseason, setIsLoadingseason);
  }, [season]);
  //season data fetch end
  //P_Tech data fetch start
  const [ptechdata, setPtechdata] = useState([]);
  const [isLoadingptech, setIsLoadingptech] = useState(false);
  useEffect(() => {
    fetchPtechnique(setPtechdata, isLoadingptech, setIsLoadingptech);
  }, [ptech]);
  //P_Tech data fetch end
  const [buyeerdata, setBuyeerdata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    let params = '&filters[dis][$ne]=Discontinue';
    fetchBuyers(setBuyeerdata, isLoadingbu, setIsLoadingbu, params);
  }, []);
  const [updateid, setUpdateId] = useState('');
  const [tempUpdateid, settempUpdateId] = useState('');
  const [vartid, setVartid] = useState('');
  const [svarid, setSVarid] = useState('');
  const [varStatus, setVarStatus] = useState(false);
  const [iddd, setIddd] = useState('');
  useEffect(() => {
    // Fetch only if editing an existing product/variant
    if (iddd && !svarid) {
      fetchDataid();
      clearCookies();
    }
  }, [iddd]);

  useEffect(() => {
    if (svarid) {
      fetchDataid(); // only fetch variant if svarid exists
    }
  }, [svarid]);

  // useEffect(() => {
  //   if (step !== 1) {
  //     // For step changes, fetch data only if editing existing variant/product
  //     if (iddd || svarid) {
  //       fetchDataid();
  //     }
  //   }
  // }, [step]);


  async function fetchImageAsFile(url, name) {
    // Fetch the image as a Blob
    const response = await fetch(url);
    const blob = await response.blob();

    // Create a File object from the Blob
    const file = new File([blob], name, { type: blob.type });

    return file;
  }
  const [varmainPrdCode, VarmainPrdCode] = useState('');
  const [isDataLoading, setIsDataLoading] = useState(false)
  const fetchDataid = async () => {
    setIsDataLoading(true)
    try {
      let response;
      if (svarid) {
        response = await fetch(`${ip}/api/variant-products?populate=*&filters[id][$eq]=${svarid}`);
        // console.log(`${ip}/api/variant-products?populate=*&filters[id][$eq]=${svarid}`);
      } else {
        response = await fetch(`${ip}/api/products?populate=*&filters[id][$eq]=${iddd}`);
      }
      const json = await response.json();
      const data = json.data[0];
      const latestCatName = await fetchNewCatName(data?.attributes?.CategoryCode);
      const latestPtypeName = await fetchNewPTypeName(data?.attributes?.ProductTypeCode);
      const latestColorName = await fetchNewColorName(data?.attributes?.ColorCode);
      const latestFinishName = await fetchNewFinishName(data?.attributes?.FinishCode);
      VarmainPrdCode(data?.attributes?.Variant_Id);
      const productionDetails = await Promise.all(
        data.attributes.ProductionDetail.map(async detail => ({
          id: detail.id,
          ProductCode: detail.ProductCode,
          MaterialNm: await fetchNewMaterialName(detail.MaterialCode) ||
            detail.MaterialNm ||
            null,
          MaterialFinishNm: detail.MaterialFinishNm,
          MatNetWeight: detail.MatNetWeight,
          MaterialCode: detail.MaterialCode,
          MaterialFinishCode: detail.MaterialFinishCode,
          Component: detail.Component,
          Unit: detail.Unit,
          Length: detail.Length,
          Width: detail.Width,
          Height: detail.Height,
          Depth: detail.Depth,
          Qty: detail.Qty,
          Remark: detail.Remark
        }))
      );
      const materialcollection = await Promise.all(
        data.attributes.MaterialCollection.map(async collection => ({
          id: collection.id, // If you have an id in your data, otherwise omit this line
          ProductCode: collection.ProductCode,
          MatCollectionNm: await fetchNewMaterialCollName(collection.MatCollectionCode),
          MatCollectionCode: collection.MatCollectionCode
        }))
      );
      const SetSizes = await Promise.all(
        data?.attributes?.SetSizes?.map(async size => ({
          id: size.id, // If you have an id in your data, otherwise omit this line
          SizeUnit: size.SizeUnit,
          Length: size.Length,
          Width: size.Width,
          Height: size.Height,
          Description: size.Description,
          ColorName: await fetchNewColorName(size.ColorCode),
          ColorCode: size.ColorCode,
          NetWt: size.NetWt,
          FinishName: await fetchNewFinishName(size.FinishCode),
          FinishCode: size.FinishCode,
          MatName: size.MatName,
          SetRate: size.SetRate
        }))
      );
      setSingleImageDeleteId(data?.attributes?.CoverImage?.data?.id);
      setMultipleImageDeleteIds((data?.attributes?.MultipleImage?.data || []).map(i => i.id) || []);
      setTotalCbm(data.attributes.Total_CBM);
      setTotalCFT(data.attributes.Total_CFT);
      setFeet20(data.attributes.TwentyFT);
      setFeet40(data.attributes.FortyFT);
      setFeet20hc(data.attributes.FortyHQ);
      setFileInfo(`${ip}${data?.attributes?.CoverImage?.data?.attributes?.url}`);
      // console.log('Image NAME :', data?.attributes?.CoverImage);
      setOrginalImg(`${ip}${data?.attributes?.CoverImage?.data?.attributes?.url}`);
      setAlias(data.attributes.ProductId);
      setMultiImages(data.attributes.MultipleImage);
      // Transform MultipleImage to initial state for dataimg
      const existingImages = (data?.attributes?.MultipleImage?.data || []).map(img => ({
        url: `${ip}${img.attributes.url}`,
        name: `${img.attributes.name}`
      }));

      // Create a separate variable to store the converted images
      const convertedFiles = [];

      for (let i = 0; i < existingImages.length; i++) {
        const image = existingImages[i];
        const file = await fetchImageAsFile(image.url, image.name); // Optionally, use a default name
        // Push the File object directly to the convertedFiles array
        convertedFiles.push(file);
      }

      // Set the dataimg state with the converted files (only File objects)
      // console.log('converted :', convertedFiles);
      setDataimg(convertedFiles);

      if (data.attributes.threeDview?.data?.attributes?.url) {
        setData51(`${ip}${data.attributes.threeDview.data.attributes.url}`);
      } else {
        setData51(null);
      }
      setSelectedCategoryCode(data.attributes.CategoryCode);
      setVarStatus(data.attributes.Variant);
      setData5(prevData => ({
        ...prevData,
        CategoryCode: data.attributes.CategoryCode,
        ProductTypeCode: data.attributes.ProductTypeCode,
        ProductCode: data.attributes.ProductCode,
        ProductId: data.attributes.ProductId,
        ProductName: data.attributes.ProductName,
        Description: data.attributes.Description,
        SizeUnit: data.attributes.SizeUnit || 'inch',
        Length: data.attributes.Length,
        Width: data.attributes.Width,
        Height: data.attributes.Height,
        FinishCode: data.attributes.FinishCode,
        ColorCode: data.attributes.ColorCode,
        NetWeight: data.attributes.NetWeight,
        GrossWeight: data.attributes.GrossWeight,
        HSNCode: data.attributes.HSNCode,
        SellingPriceCurrency: data.attributes.SellingPriceCurrency,
        SellingPriceUnit: data.attributes.SellingPriceUnit,
        SellingPrice: data.attributes.SellingPrice,
        ProductCost: data.attributes.ProductCost,
        SearchKeyword: data.attributes.SearchKeyword,
        MOQ: data.attributes.MOQ,
        ProductDesigner: data.attributes.ProductDesigner,
        MadeBy: data.attributes.MadeBy,
        CategoryName: latestCatName,
        ProductTypeName: latestPtypeName,
        cbm: data.attributes.cbm,
        Shape: data.attributes.Shape,
        Season: data.attributes.Season,
        P_Technique: data.attributes.P_Technique,
        FinishName: latestFinishName,
        ColorName: latestColorName,
        BuyerName: data.attributes.BuyerName,
        BuyerSku: data.attributes.BuyerSku,
        SizeRange: data.attributes.SizeRange,
        Total_CBM: data.attributes.Total_CBM,
        Total_CFT: data.attributes.Total_CFT,
        TwentyFT: data.attributes.TwentyFT,
        FortyFT: data.attributes.FortyFT,
        FortyHQ: data.attributes.FortyHQ,
        Product_Remark: data.attributes.Product_Remark,
        Buyer_Remark: data.attributes.Buyer_Remark,
        SetStatus: data.attributes.SetStatus,
        Part: data.attributes.Part,
        Authorized: data.attributes.Authorized,
        CoverImage: `${ip}${data?.attributes?.CoverImage?.data?.attributes?.url}`,
        ProductionDetail: productionDetails,
        MaterialCollection: materialcollection,
        L: data.attributes.L,
        M: data.attributes.M,
        MX: data.attributes.MX,
        Packaging: data.attributes.Packaging.map(pack => ({
          id: pack.id, // If you have an id in your data, otherwise omit this line
          CartonType: pack.CartonType,
          ProductCode: pack.ProductCode,
          Carton_Unit: pack.Carton_Unit,
          Carton_Length: pack.Carton_Length,
          Carton_Width: pack.Carton_Width,
          Carton_Thick: pack.Carton_Thick,
          Carton_CBM: pack.Carton_CBM,
          Carton_PCS: pack.Carton_PCS,
          Carton_CBMperpc: pack.Carton_CBMperpc,
          Carton_GrsWt: pack.Carton_GrsWt
        })),
        SetSizes: SetSizes
      }));

      setName(data.attributes.CoverImage.data.attributes.name);
      setUpdateId(data.id);
      settempUpdateId(data.id);
      // await fetchNewCatName();
      // await fetchNewPTypeName();
    } catch (error) {
      console.error('Error fetching category data:', error);
    } finally {
      setIsDataLoading(false)
    }
  };
  // Now you can use this ID to fetch the data associated with the selected item
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const varrrtid = searchParams.get('id') || '';
    const pid = searchParams.get('pId') || '';
    const svid = searchParams.get('svid') || '';
    setIddd(pid);
    setVartid(varrrtid);
    setSVarid(svid);
  }, [location]);

  const [variantttdata, setVariantttdata] = useState([]);
  useEffect(() => {
    if (vartid) {
      fetchDatavar();
    }
  }, [vartid, step == 1]);
  const fetchDatavar = async () => {
    try {
      const response = await fetch(
        `${ip}/api/variant-products?populate=*&filters[Variant_Id][$eq]=${vartid}`
      );
      const json = await response.json();
      const sortedData = json.data.sort((a, b) => {
        const idA = a.attributes.ProductId;
        const idB = b.attributes.ProductId;

        // If numeric part matters, extract number from HT00115-4
        const numA = parseInt(idA.split('-')[1] || '0', 10);
        const numB = parseInt(idB.split('-')[1] || '0', 10);

        return numA - numB; // ascending, for descending use: numB - numA
      });
      setVariantttdata(sortedData);
      // setIddd(json.data[0]?.id);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [numVariants, setNumVariants] = useState(null);
  const [variantData, setVariantData] = useState([]);
  const [isLoadingColor, setIsLoadingColor] = useState(false);
  const [colorOptions, setColorOptions] = useState([]);
  const [showColor, setShowColor] = useState(false);
  const [showPname, setPName] = useState(false);
  const [showFinish, setShowFinish] = useState(false);
  const [showSize, setShowSize] = useState(false);
  const [showLength, setShowLength] = useState(false);
  const [showWidth, setShowWidth] = useState(false);
  const [showHeight, setShowHeight] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  const [showMoq, setShowMoq] = useState(false);
  const [showNTW, setShowNTW] = useState(false);
  const [showGRW, setShowGRW] = useState(false);
  const [showMat, setShowMat] = useState(false);
  const [showbuyersku, setbuyersku] = useState(false);
  // console.log('variantData' , variantData)
  // Simulate loading color options from an API

  useEffect(() => {
    if (!isLoadingColor) {
      setIsLoadingColor(true);

      // Replace this with your API call to fetch color options
      setTimeout(() => {
        const mockColorOptions = [
          { label: 'Red', value: 'red' },
          { label: 'Blue', value: 'blue' },
          { label: 'Green', value: 'green' }
        ];
        setColorOptions(mockColorOptions);
        setIsLoadingColor(false);
      }, 1000); // Simulate API delay
    }
  }, [isLoadingColor]);
  const [addingVariants, setAddingVariants] = useState(false);
  const handleAddVariants = async () => {
    try {
      setVariantImageChanged(false);

      // 🔹 Fetch latest product codes (keep your original logic)
      const { data: prcode } = await axios.get(`${globalIP}/api/products?populate=*`);

      const originalProductId = data5.ProductId; // base e.g. K-01
      const totalExisting = prcode.meta.pagination.total;

      // 🔹 Extract numeric suffixes from existing backend variants
      const existingSuffixes = variantttdata
        .map(item => {
          const id = item.attributes?.ProductId;
          const match = id?.match(/-(\d+)$/);
          return match ? parseInt(match[1], 10) : 0;
        })
        .filter(num => num > 0);

      // 🔹 Get current max suffix (or 0 if none)
      let maxSuffix = existingSuffixes.length ? Math.max(...existingSuffixes) : 0;

      const newVariantData = [];
      let nextCode = totalExisting + 1;

      for (let i = 0; i < numVariants; i++) {
        const nextSuffix = ++maxSuffix; // continue proper numbering

        const nextProductCode = `PRD-${nextCode.toString().padStart(3, "0")}`;

        // 🧩 keep your original data copy logic
        const variant = {
          ...data5,
          ProductCode: nextProductCode,
          Variant_Id: updateid
            ? varmainPrdCode
            : `PRD-${(nextCode - 1).toString().padStart(3, "0")}`,
          ProductId: `${originalProductId}-${nextSuffix}`,
          color: undefined,
          finish: undefined,
          size: undefined,
          length: undefined,
          width: undefined,
          height: undefined,
          desc: undefined,
          productname: undefined,
          moq: undefined,
          Ntw: undefined,
          Grw: undefined,
          Mat: undefined
        };

        // ✅ preserve your conditional field copies
        if (showColor) variant.ColorName = data5.ColorName;
        if (showPname) variant.ProductName = data5.ProductName;
        if (showFinish) variant.FinishName = data5.FinishName;
        if (showSize) variant.SizeUnit = data5.SizeUnit;
        if (showLength) variant.Length = data5.Length;
        if (showWidth) variant.Width = data5.Width;
        if (showHeight) variant.Height = data5.Height;
        if (showDesc) variant.Description = data5.Description;
        if (showMoq) variant.MOQ = data5.MOQ;
        if (showNTW) variant.NetWeight = data5.NetWeight;
        if (showGRW) variant.GrossWeight = data5.GrossWeight;

        // ✅ preserve material copy logic
        variant.ProductionDetail = data5.ProductionDetail.map(detail => ({
          ...detail,
          MaterialNm: detail.MaterialNm
        }));

        newVariantData.push(variant);
        nextCode++;
      }

      // ✅ set all in one go (no race condition)
      setVariantData(newVariantData);
      setOpen(false);
      setAddingVariants(true);
    } catch (error) {
      console.error("Error while adding variants:", error);
    }
  };

  // const handleAddVariants = async () => {
  //   setVariantImageChanged(false);
  //   const { data: prcode } = await axios.get(`${globalIP}/api/products?populate=*`);
  //   if (updateid === '' || updateid === null) {
  //     const originalProductId = data5.ProductId;
  //     const newVariantData = [];
  //     let nextCode = prcode.meta.pagination.total + 2;
  //     let nextCode2 = prcode.meta.pagination.total + 1;
  //     const nextCategoryCode2 = `PRD-${nextCode2.toString().padStart(3, '0')}`;
  //     for (let i = 0; i < numVariants; i++) {
  //       // Create a copy of the original data for each variant
  //       let nextCategoryCode = `PRD-${nextCode.toString().padStart(3, '0')}`;
  //       const variant = {
  //         ...data5, // Include all properties from data5
  //         ProductCode: nextCategoryCode,
  //         Variant_Id: nextCategoryCode2,
  //         ProductId: `${originalProductId}-${i + 1 + variantttdata.length}`,

  //         // Exclude variant-specific properties
  //         color: undefined,
  //         finish: undefined,
  //         size: undefined,
  //         length: undefined,
  //         width: undefined,
  //         height: undefined,
  //         desc: undefined,
  //         productname: undefined,
  //         moq: undefined,
  //         Ntw: undefined,
  //         Grw: undefined,
  //         Mat: undefined
  //       };
  //       // Customize the variant as needed
  //       if (showColor) {
  //         variant.ColorName = data5.ColorName; // Set a default value, you can change this
  //       }
  //       if (showPname) {
  //         variant.ProductName = data5.ProductName; // Set a default value, you can change this
  //       }
  //       if (showFinish) {
  //         variant.FinishName = data5.FinishName; // Set a default value, you can change this
  //       }
  //       if (showSize) {
  //         variant.SizeUnit = data5.SizeUnit; // Set a default value, you can change this
  //       }
  //       if (showLength) {
  //         variant.Length = data5.Length; // Set a default value, you can change this
  //       }
  //       if (showWidth) {
  //         variant.Width = data5.Width; // Set a default value, you can change this
  //       }
  //       if (showHeight) {
  //         variant.Height = data5.Height; // Set a default value, you can change this
  //       }
  //       if (showDesc) {
  //         variant.Description = data5.Description; // Set a default value, you can change this
  //       }
  //       if (showMoq) {
  //         variant.MOQ = data5.MOQ; // Set a default value, you can change this
  //       }
  //       if (showNTW) {
  //         variant.NetWeight = data5.NetWeight; // Set a default value, you can change this
  //       }
  //       if (showGRW) {
  //         variant.GrossWeight = data5.GrossWeight; // Set a default value, you can change this
  //       }
  //       const productionDetails = data5.ProductionDetail.map(detail => ({
  //         ...detail,
  //         MaterialNm: detail.MaterialNm // Add MaterialName dynamically
  //       }));

  //       variant.ProductionDetail = productionDetails;
  //       newVariantData.push(variant);
  //       nextCode++;
  //     }
  //     setVariantData(newVariantData);
  //     setOpen(false);
  //     setAddingVariants(true);
  //   } else {
  //     const originalProductId = data5.ProductId;
  //     const newVariantData = [];
  //     let nextCode = prcode.meta.pagination.total + 2;
  //     for (let i = 0; i < numVariants; i++) {
  //       // Create a copy of the original data for each variant
  //       let nextCategoryCode = `PRD-${nextCode.toString().padStart(3, '0')}`;
  //       const variant = {
  //         ...data5, // Include all properties from data5
  //         ProductCode: nextCategoryCode,
  //         Variant_Id: varmainPrdCode,
  //         ProductId: `${originalProductId}-${i + 1 + variantttdata.length}`,

  //         // Exclude variant-specific properties
  //         color: undefined,
  //         finish: undefined,
  //         size: undefined,
  //         length: undefined,
  //         width: undefined,
  //         height: undefined,
  //         desc: undefined,
  //         productname: undefined,
  //         moq: undefined,
  //         Ntw: undefined,
  //         Grw: undefined,
  //         Mat: undefined
  //       };
  //       // Customize the variant as needed
  //       if (showColor) {
  //         variant.ColorName = data5.ColorName; // Set a default value, you can change this
  //       }
  //       if (showPname) {
  //         variant.ProductName = data5.ProductName; // Set a default value, you can change this
  //       }
  //       if (showFinish) {
  //         variant.FinishName = data5.FinishName; // Set a default value, you can change this
  //       }
  //       if (showSize) {
  //         variant.SizeUnit = data5.SizeUnit; // Set a default value, you can change this
  //       }
  //       if (showLength) {
  //         variant.Length = data5.Length; // Set a default value, you can change this
  //       }
  //       if (showWidth) {
  //         variant.Width = data5.Width; // Set a default value, you can change this
  //       }
  //       if (showHeight) {
  //         variant.Height = data5.Height; // Set a default value, you can change this
  //       }
  //       if (showDesc) {
  //         variant.Description = data5.Description; // Set a default value, you can change this
  //       }
  //       if (showMoq) {
  //         variant.MOQ = data5.MOQ; // Set a default value, you can change this
  //       }
  //       if (showNTW) {
  //         variant.NetWeight = data5.NetWeight; // Set a default value, you can change this
  //       }
  //       if (showGRW) {
  //         variant.GrossWeight = data5.GrossWeight; // Set a default value, you can change this
  //       }
  //       const productionDetails = data5.ProductionDetail.map(detail => ({
  //         ...detail,
  //         MaterialNm: detail.MaterialNm // Add MaterialName dynamically
  //       }));
  //       variant.ProductionDetail = productionDetails;
  //       newVariantData.push(variant);
  //       nextCode++;
  //     }
  //     setVariantData(newVariantData);
  //     setOpen(false);
  //     setAddingVariants(true);
  //   }
  // };

  const handleRemoveVariant = indexToRemove => {
    const updatedVariants = [...variantData];
    updatedVariants.splice(indexToRemove, 1); // Remove the variant at the specified index
    setVariantData(updatedVariants);
    if (updatedVariants.length === 0) {
      setVariantImageChanged(true);
    }
  };
  const [isVariantSubmitting, setIsVariantSubmitting] = useState(false)
  const handleSaveVariantData = () => {
    setIsVariantSubmitting(true)
    variantData.forEach((variant, index) => {
      const formData = new FormData();
      // Append the variant data to the formData
      formData.append('files.CoverImage', variant.CoverImage);
      formData.append('files.MultipleImage', variant.MultipleImage);
      variant.MaterialCollection.forEach((collection, matIndex) => {
        formData.append(`data.MaterialCollection[${matIndex}].ProductCode`, variant.ProductCode);
        formData.append(
          `data.MaterialCollection[${matIndex}].MatCollectionNm`,
          collection.MatCollectionNm
        );
        formData.append(
          `data.MaterialCollection[${matIndex}].MatCollectionCode`,
          collection.MatCollectionCode
        );
      });
      // console.log(variant.ProductionDetail.length);
      if (variant.ProductionDetail.length > 0) {
        variant.ProductionDetail[0].ProductCode = variant.ProductCode;
      }
      variant.ProductionDetail.forEach((material, matIndex) => {
        formData.append(`ProductionDetail[${matIndex}][ProductCode]`, variant.ProductCode);
        formData.append(`ProductionDetail[${matIndex}][MaterialNm]`, material.MaterialNm);
        formData.append(
          `ProductionDetail[${matIndex}][MaterialFinishNm]`,
          material.MaterialFinishNm
        );
        formData.append(
          `ProductionDetail[${matIndex}][MatNetWeight]`,
          String(material.MatNetWeight)
        );
        formData.append(`ProductionDetail[${matIndex}][MaterialCode]`, material.MaterialCode);
        formData.append(
          `ProductionDetail[${matIndex}][MaterialFinishCode]`,
          material.MaterialFinishCode
        );
      });

      formData.append('data', JSON.stringify(variant));
      // Send the variant data to your API
      fetch(url3, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          fetchDatavar()
          setVariantData([])
          // setIsVariantSubmitting(false)
          // console.log(data);
          // You can perform any additional actions here, such as displaying a success message
        })
        .catch(error => {
          console.error(`Error saving Variant ${index + 1}:`, error);
          // setIsVariantSubmitting(false)
          // Handle errors accordingly
        }).finally(() => setIsVariantSubmitting(false));
    });
    // Now, you have successfully saved all variants
  };

  const [variantImageChanged, setVariantImageChanged] = useState(false);
  const resizeFile = blobfile =>
    new Promise(resolve => {
      Resizer.imageFileResizer(
        blobfile,
        1500,
        1500,
        'JPEG',
        90,
        0,
        uri => {
          resolve(uri);
        },
        'base64',
        900,
        900
      );
    });

  function base64ToBlob(base64, mimeType) {
    // Decode the base64 string into a byte array
    const byteCharacters = atob(base64.split(',')[1]);

    // Create a byte array of the same length as the decoded data
    const byteArrays = [];
    // Convert each character to its byte value
    for (let offset = 0; offset < byteCharacters.length; offset++) {
      byteArrays.push(byteCharacters.charCodeAt(offset));
    }
    // Create a Blob object using the byte arrays and the MIME type
    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: mimeType });
  }
  const handleUploadVarImage = async (fileList, rowIndex) => {
    if (fileList.length > 0) {
      const uploadedFile = fileList[0];

      // Check if the uploaded file is a JPG or JPEG image
      if (
        uploadedFile.type === 'image/jpeg' ||
        uploadedFile.type === 'image/jpg' ||
        uploadedFile.name.toLowerCase().endsWith('.jpg') ||
        uploadedFile.name.toLowerCase().endsWith('.jpeg')
      ) {
        // Update the customCoverImage property for the corresponding variant
        const updatedVariantData = [...variantData];
        updatedVariantData[rowIndex].customCoverImage = await resizeFile(uploadedFile.blobFile);

        // Update the CoverImage property to match the custom image
        updatedVariantData[rowIndex].CoverImage = base64ToBlob(
          updatedVariantData[rowIndex].customCoverImage,
          uploadedFile.type
        ); // Save the custom image blob
        setVariantData(updatedVariantData);

        let allImagesChanged = true;
        for (let i = 0; i < updatedVariantData.length; i++) {
          if (!updatedVariantData[i].customCoverImage) {
            allImagesChanged = false;
            break;
          }
        }
        setVariantImageChanged(allImagesChanged);
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        // Show an error message or take other appropriate action for invalid file types
        console.error('Invalid file type. Please upload only JPG or JPEG images.');
        toaster.push(
          <Message showIcon type="error">
            Please Change. Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
    setVarit(1);
  };

  useEffect(() => {
    checkVariantData();
  }, [variantttdata, variantData]);
  const checkVariantData = () => {
    if (variantttdata.length > 0 || variantData.length > 0) {
      setVarStatus(true);
    } else {
      setVarStatus(false);
    }
  };
  const [open4, setOpen4] = React.useState(false);
  const [productsaved, setProductsaved] = useState(false);
  const handleOpen4 = () => {
    setOpen4(true);
    setProductsaved(true);
  };
  const handleClose4 = () => {
    setOpen4(false);
    const params = new URLSearchParams(location.search);
    if (!params.get('showPopup') === 'true') {
      window.location.reload();
    }
  };
  const onChange1 = () => {
    handleOpen4();
  };

  const [open5, setOpen5] = React.useState(false);
  const handleOpen5 = () => setOpen5(true);
  const handleClose5 = () => {
    setOpen5(false);

    // If step = 1, do nothing (your old logic)
    if (step === 1) return;

    // Reset to step 0
    setStep(0);
  };

  const onChange2 = () => {
    handleOpen5();
  };
  const [curr, setCurr] = useState([]);

  useEffect(() => {
    fetchDatacurr();
  }, []);

  const fetchDatacurr = async () => {
    try {
      const response = await fetch(`${ip}/api/currency-masters`);
      const json = await response.json();

      const currency = json.data.map(item => ({
        label: item.attributes.currencyname, // Setting label
        value: item.attributes.currencyname, // Setting value
        exchangerate: item.attributes.exchangerate
      }));
      setCurr(currency);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);
  const [auth, setAuth] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  const [finShow, setFinShow] = useState(false);
  const [aliasauto, setAliasauto] = useState(null);
  const handleProductionDetailChange = (index, field, value) => {
    setData5(prevData => {
      const updatedDetails = [...prevData.ProductionDetail];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
        ProductCode: updateid ? data5.ProductCode : generateNextCategoryCode()
      };
      return {
        ...prevData,
        ProductionDetail: updatedDetails
      };
    });
  };
  const handleMultiSizeChange = (index, field, value) => {
    setData5(prevData => {
      const updatedDetails = [...prevData.SetSizes];

      if (field === 'ColorName') {
        // Find the corresponding ColorCode from colordata
        const selectedColor = colordata.find(color => color.label === value);
        updatedDetails[index] = {
          ...updatedDetails[index],
          ColorName: value,
          ColorCode: selectedColor ? selectedColor.value : '' // Set ColorCode or empty if not found
        };
      } else if (field === 'FinishName') {
        // Find the corresponding ColorCode from colordata
        const selectedFinish = finishdata.find(finish => finish.label === value);
        updatedDetails[index] = {
          ...updatedDetails[index],
          FinishName: value,
          FinishCode: selectedFinish ? selectedFinish.value : '' // Set ColorCode or empty if not found
        };
      } else if (field === 'SetRate') {
        // Find the corresponding ColorCode from colordata

        updatedDetails[index] = {
          ...updatedDetails[index],
          SetRate: Number(value)
        };
      } else {
        updatedDetails[index] = {
          ...updatedDetails[index],
          [field]: value
        };
      }
      // console.log('updated :', updatedDetails);

      return {
        ...prevData,
        SetSizes: updatedDetails
      };
    });
  };
  const [options, setOptions] = useState([
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' }
  ]);

  const [showModal, setShowModal] = useState(false);
  const [cbmeditdata, setCbmEditData] = useState(null);
  const handleOpencbm = rowIndex => {
    setCbmEditData(rowIndex);
    setShowModal(true);
    // Your logic for handling the modal opening
    // console.log('Opening CBM modal for row:', rowIndex);
  };
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 270; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const [processing, setProcessing] = useState(false);
  const blurStyle = {
    filter: "blur(4px)",
    pointerEvents: "none",
    opacity: 0.5,
    transition: "all 0.3s ease"
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.4)",
    backdropFilter: "blur(5px)",
    zIndex: 10
  };

  return (
    <>
      <Container className="main table-toolbar">
        <Stack justifyContent="space-between">
          <div className="nav-section">
            <h3 className="title">Product Create</h3>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={`/${ugr}/dashboard`}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/${ugr}/products`}>Product</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Product Create</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {auth && (
            <SelectPicker
              data={authstatus}
              value={data5.Authorized}
              onChange={value => {
                setData5({ ...data5, Authorized: value });
              }}
              placement="auto"
              searchable={false}
            />
          )}
        </Stack>
        <Steps current={step} className="step">
          <Steps.Item title="Basic Information" />
          <Steps.Item title="Product Family(Variants)" />
          <Steps.Item title="Package Loadability" />
        </Steps>

        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />

        <div style={{ display: step === 0 ? "block" : "none" }}>
          <FlexboxGrid justify="space-between">
            <ImageSection
              {...{
                setFileInfo,
                orginalImg,
                setOrginalImg,
                setMultiImgScroll,
                setData5,
                setName,
                compndata,
                setNum,
                fileInfo,
                setNum1,
                data5,
                name,
                setDataimg,
                dataimg,
                setUpdateId,
                data51,
                setData51,
                resizeFile,
                base64ToBlob,
                setProcessing,
                processing
              }}
            />

            <FlexboxGrid.Item as={Col} colspan={24} md={18}>
              <Form className="formScroll" style={{ height: tableHeight }}>
                <Divider style={{ marginTop: '15px', marginBottom: '10px' }}>
                  <b>Basic Information</b>
                </Divider>
                <FlexboxGrid justify="space-around" style={{ marginBottom: '15px' }}>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>
                        <Stack>
                          <p>{label[0]?.attributes?.Category}</p>
                          <p style={{ color: 'red' }}>*</p>
                        </Stack>
                      </Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          id="CategoryName"
                          name="CategoryName"
                          value={data5.CategoryName}
                          onChange={value => handleInputChange('CategoryName', value, 0)}
                          data={categorydata}
                          placeholder="Select"
                          labelKey="label"
                          valueKey="label"
                          menuMaxHeight={180}
                          menuStyle={{ width: 200 }}
                          block
                          container={() => document.getElementById('custom-container')}
                          onOpen={() => fetchCategory(setCategorydata, isLoadingc, setIsLoadingc)}
                          renderExtraFooter={() => (
                            <Stack justifyContent="space-between" spacing={5}>
                              <Input
                                placeholder={`Add ${label[0]?.attributes?.Category}`}
                                value={
                                  category && category.CategoryName ? category.CategoryName : ''
                                }
                                onChange={value =>
                                  handleInputChangemstcat('CategoryName', value, 0)
                                }
                              />
                              <Input
                                placeholder="Short Name"
                                value={category && category.ShortName ? category.ShortName : ''}
                                onChange={value => handleInputChangemstcat('ShortName', value, 0)}
                              />
                              <IconButton
                                icon={<PlusIcon />}
                                appearance="primary"
                                color="cyan"
                                onClick={submit1}
                              />
                            </Stack>
                          )}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.ProductType}</Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          id="ProductTypeName"
                          name="ProductTypeName"
                          value={data5.ProductTypeName || ''}
                          onChange={value => handleInputChange('ProductTypeName', value, 0)}
                          data={productypedata}
                          placeholder="Select"
                          labelKey="label"
                          valueKey="label"
                          menuMaxHeight={180}
                          menuStyle={{ width: 200 }}
                          block
                          container={() => document.getElementById('custom-container')}
                          onOpen={() =>
                            fetchProductTypes(
                              setProductypedata,
                              isLoadingpro,
                              selectedCategoryCode,
                              setIsLoadingpro
                            )
                          }
                          renderExtraFooter={() => (
                            <Stack justifyContent="space-between">
                              <Input
                                placeholder={`Add ${label[0]?.attributes?.ProductType}`}
                                value={
                                  productType && productType.ProductTypeName
                                    ? productType.ProductTypeName
                                    : ''
                                }
                                onChange={value => handleInputChange2('ProductTypeName', value, 0)}
                              />
                              <IconButton
                                icon={<PlusIcon />}
                                appearance="primary"
                                color="cyan"
                                onClick={handleClick}
                              />
                            </Stack>
                          )}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>
                        <Stack>
                          <p>Set Status</p>
                          <p style={{ color: 'red' }}>*</p>
                        </Stack>
                      </Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          id="SetStatus"
                          name="SetStatus"
                          value={data5.SetStatus || 'Single'}
                          onChange={value => handleInputChange('SetStatus', value, 0)}
                          data={setstatus}
                          block
                          cleanable={false}
                          container={() => document.getElementById('custom-container')}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>
                        <Stack>
                          <p>Part</p>
                        </Stack>
                      </Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          data={options}
                          style={{ width: 224 }}
                          // value={data5 && data5.Part ? data5.Part : 1}
                          value={String(data5?.Part) ?? '1'}
                          onChange={value => handleInputChange('Part', value, 0)}
                          disabled={data5.SetStatus === 'Single'}
                          container={() => document.getElementById('custom-container')}
                          menuMaxHeight={180}
                          searchable={false}
                          placeholder="Select Part"
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>
                        <Stack>
                          <p>{label[0]?.attributes?.AliasCode}</p>
                          <p style={{ color: 'red' }}>*</p>
                        </Stack>
                      </Form.ControlLabel>
                      <Input
                        id="ProductId"
                        name="ProductId"
                        autocomplete="off"
                        value={data5 && data5.ProductId ? data5.ProductId : ''}
                        onChange={value => handleInputChange('ProductId', value, 0)}
                        readOnly={aliasauto == 'Cate.Shortname + Auto'}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item as={Col} colspan={24} md={16}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>
                        <Stack>
                          <p>{label[0]?.attributes?.ProductName}</p>
                          <p style={{ color: 'red' }}>*</p>
                        </Stack>
                      </Form.ControlLabel>
                      <Input
                        id="ProductName"
                        name="ProductName"
                        value={data5 && data5.ProductName ? data5.ProductName : ''}
                        onChange={value => handleInputChange('ProductName', value, 0)}
                        autocomplete="off"
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.Shape}</Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          data={shapedata}
                          labelKey="label"
                          valueKey="label"
                          id="Shape"
                          name="Shape"
                          value={data5 && data5.Shape ? data5.Shape : ''}
                          onChange={value => handleInputChange('Shape', value, 0)}
                          onOpen={() => fetchShape(setShapedata, isLoadingshape, setIsLoadingshape)}
                          menuStyle={{ width: 200 }}
                          container={() => document.getElementById('custom-container')}
                          block
                          renderExtraFooter={() => (
                            <Stack justifyContent="space-between">
                              <StackItem grow={1}>
                                <Input
                                  placeholder={`Add ${label[0]?.attributes?.Shape}`}
                                  value={shape && shape.ShapeName ? shape.ShapeName : ''}
                                  onChange={value => handleInputChange8('ShapeName', value, 0)}
                                />
                              </StackItem>
                              <IconButton
                                icon={<PlusIcon />}
                                appearance="primary"
                                color="cyan"
                                onClick={submit8}
                              />
                            </Stack>
                          )}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <Form fluid style={{ marginBottom: '15px', marginTop: '10px' }}>
                  <Form.Group controlId="textarea-1">
                    <Form.ControlLabel>{label[0]?.attributes?.Description}</Form.ControlLabel>
                    <Form.Control
                      id="Description"
                      name="Description"
                      value={data5 && data5.Description ? data5.Description : ''}
                      onChange={value => handleInputChange('Description', value, 0)}
                      placeholder="Textarea"
                      accepter={Textarea}
                    />
                  </Form.Group>
                </Form>
                {data5.SetStatus === 'Single' ? (
                  <>
                    {!sizeshow ? (
                      <FlexboxGrid justify="space-between" style={{ marginBottom: '20px' }}>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.Group controlId="input-group">
                            <Form.ControlLabel>{label[0]?.attributes?.Sizeunit}</Form.ControlLabel>
                            <div id="custom-container" style={{ position: 'relative' }}>
                              <InputPicker
                                data={siii}
                                cleanable={false}
                                id="SizeUnit"
                                name="SizeUnit"
                                container={() => document.getElementById('custom-container')}
                                value={data5 && data5.SizeUnit ? data5.SizeUnit : 'inch'}
                                onChange={value => handleInputChange('SizeUnit', value, 0)}
                                block
                              />
                            </div>
                          </Form.Group>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.Group controlId="input-group">
                            <Form.ControlLabel>{label[0]?.attributes?.length}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              style={{ width: 'auto' }}
                              id="Length"
                              name="Length"
                              value={data5 && data5.Length ? data5.Length : 0}
                              onChange={value => handleInputChange('Length', value, 0)}
                            />
                          </Form.Group>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.Group controlId="input-group">
                            <Form.ControlLabel>{label[0]?.attributes?.width}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              style={{ width: 'auto' }}
                              id="Width"
                              name="Width"
                              value={data5 && data5.Width ? data5.Width : 0}
                              onChange={value => handleInputChange('Width', value, 0)}
                            />
                          </Form.Group>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.Group controlId="input-group">
                            <Form.ControlLabel>{label[0]?.attributes?.height}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              style={{ width: 'auto' }}
                              id="Height"
                              name="Height"
                              value={data5 && data5.Height ? data5.Height : 0}
                              onChange={value => handleInputChange('Height', value, 0)}
                            />
                          </Form.Group>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                          <Form.Group>
                            <Form.ControlLabel>{label[0]?.attributes?.cbm}</Form.ControlLabel>
                            <Input readOnly value={result} />
                          </Form.Group>
                        </FlexboxGrid.Item>
                      </FlexboxGrid>
                    ) : (
                      <Form.Group>
                        <Form.ControlLabel>{label[0]?.attributes?.SizeRange}</Form.ControlLabel>
                        <Input
                          id="SizeRange"
                          name="SizeRange"
                          value={data5 && data5.SizeRange ? data5.SizeRange : ''}
                          onChange={value => handleInputChange('SizeRange', value, 0)}
                        />
                      </Form.Group>
                    )}
                  </>
                ) : (
                  <FlexboxGrid justify="space-between" style={{ marginBottom: '10px' }}>
                    {data5?.SetSizes?.map((prodct, index) => (
                      <>
                        <div key={`${'setisize' + index}`} style={{ marginTop: '8px' }}>
                          <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                            <Form.ControlLabel>Part Desc.</Form.ControlLabel>
                            <Input
                              name={`Description_${index}`}
                              value={prodct.Description}
                              onChange={value => handleMultiSizeChange(index, 'Description', value)}
                              placeholder="Textarea"
                            />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                            <Form.ControlLabel>{label[0]?.attributes?.Sizeunit}</Form.ControlLabel>
                            <div id="custom-container" style={{ position: 'relative' }}>
                              <InputPicker
                                data={siii}
                                container={() => document.getElementById('custom-container')}
                                name={`SizeUnit_${index}`}
                                value={prodct.SizeUnit || 'inch'}
                                placement="auto"
                                cleanable={false}
                                onChange={value => handleMultiSizeChange(index, 'SizeUnit', value)}
                              />
                            </div>
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                            <Form.ControlLabel>{label[0]?.attributes?.length}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              name={`Length_${index}`}
                              value={prodct.Length || 0}
                              onChange={value => handleMultiSizeChange(index, 'Length', value)}
                              min={0}
                            />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                            <Form.ControlLabel>{label[0]?.attributes?.width}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              name={`Width_${index}`}
                              value={prodct.Width || 0}
                              onChange={value => handleMultiSizeChange(index, 'Width', value)}
                              min={0}
                            />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                            <Form.ControlLabel>{label[0]?.attributes?.height}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              name={`Height_${index}`}
                              value={prodct.Height || 0}
                              onChange={value => handleMultiSizeChange(index, 'Height', value)}
                              min={0}
                            />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                            <Form.ControlLabel>{label[0]?.attributes?.NetWgt}</Form.ControlLabel>
                            <InputNumber
                              step={null}
                              name={`NetWt_${index}`}
                              value={prodct.NetWt || 0}
                              onChange={value => handleMultiSizeChange(index, 'NetWt', value)}
                              min={0}
                            />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                            <Form.ControlLabel>{label[0]?.attributes?.cbm}</Form.ControlLabel>
                            <InputNumber readOnly value={prodct.cbm} />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                            <Form.ControlLabel>{label[0]?.attributes?.color}</Form.ControlLabel>
                            <div id="custom-container" style={{ position: 'relative' }}>
                              <SelectPicker
                                name={`ColorName_${index}`}
                                value={prodct.ColorName || ''}
                                onChange={value => handleMultiSizeChange(index, 'ColorName', value)}
                                data={colordata}
                                placeholder={`Select ${label[0]?.attributes?.color}`}
                                labelKey="label"
                                valueKey="label"
                                block
                                container={() => document.getElementById('custom-container')}
                                menuMaxHeight={180}
                                menuStyle={{ width: 200 }}
                                onOpen={() =>
                                  fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor)
                                }
                                placement="auto"
                                renderExtraFooter={() => (
                                  <Stack justifyContent="space-between">
                                    <Input
                                      placeholder={`Add ${label[0]?.attributes?.color}`}
                                      value={color && color.ColorName ? color.ColorName : ''}
                                      onChange={value => {
                                        handleInputChange5('ColorName', value, 0);
                                        handleMultiSizeChange(index, 'ColorName', value);
                                      }}
                                    />
                                    <IconButton
                                      icon={<PlusIcon />}
                                      appearance="primary"
                                      color="cyan"
                                      onClick={e => {
                                        submit5(e);
                                        setCurrColorIndex(index);
                                      }}
                                    />
                                  </Stack>
                                )}
                              />
                            </div>
                          </FlexboxGrid.Item>
                        </div>
                        <div key={'fin' + index} style={{ marginTop: '8px' }}>
                          {finShow && (
                            <>
                              <FlexboxGrid.Item as={Col} colspan={24} md={5}>
                                <Form.ControlLabel>
                                  {label[0]?.attributes?.finish}
                                </Form.ControlLabel>
                                <div id="custom-container" style={{ position: 'relative' }}>
                                  <SelectPicker
                                    name={`FinishName_${index}`}
                                    value={prodct.FinishName || ''}
                                    onChange={value =>
                                      handleMultiSizeChange(index, 'FinishName', value)
                                    }
                                    data={finishdata}
                                    placeholder={`Select ${label[0]?.attributes?.finish}`}
                                    labelKey="label"
                                    valueKey="label"
                                    block
                                    container={() => document.getElementById('custom-container')}
                                    menuMaxHeight={180}
                                    menuStyle={{ width: 200 }}
                                    onOpen={() =>
                                      fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin)
                                    }
                                    placement="auto"
                                    renderExtraFooter={() => (
                                      <Stack justifyContent="space-between">
                                        <Input
                                          placeholder={`Add ${label[0]?.attributes?.finish}`}
                                          value={
                                            finish && finish.FinishName ? finish.FinishName : ''
                                          }
                                          onChange={value => {
                                            handleInputChange4('FinishName', value, 0);
                                            handleMultiSizeChange(index, 'FinishName', value);
                                          }}
                                        />
                                        <IconButton
                                          icon={<PlusIcon />}
                                          appearance="primary"
                                          color="cyan"
                                          onClick={e => {
                                            submit4(e);
                                            setCurrFinishIndex(index);
                                          }}
                                        />
                                      </Stack>
                                    )}
                                  />
                                </div>
                              </FlexboxGrid.Item>
                              <FlexboxGrid.Item as={Col} colspan={24} md={5}>
                                <Form.ControlLabel>Mat. Name</Form.ControlLabel>
                                <Input
                                  name={`MatName_${index}`}
                                  value={prodct.MatName || ''}
                                  onChange={value => handleMultiSizeChange(index, 'MatName', value)}
                                />
                              </FlexboxGrid.Item>
                              <FlexboxGrid.Item as={Col} colspan={24} md={5}>
                                <Form.ControlLabel>{'SetRate'}</Form.ControlLabel>
                                <InputNumber
                                  step={null}
                                  name={`SetRate_${index}`}
                                  value={prodct.SetRate || 0}
                                  onChange={value => handleMultiSizeChange(index, 'SetRate', value)}
                                  min={0}
                                />
                              </FlexboxGrid.Item>
                            </>
                          )}
                        </div>
                      </>
                    ))}
                  </FlexboxGrid>
                )}
                <FlexboxGrid justify="start" style={{ marginBottom: '20px' }}>
                  {data5.SetStatus === 'Single' && (
                    <>
                      <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                        <Form.Group controlId="input-group">
                          <Form.ControlLabel>{label[0]?.attributes?.color}</Form.ControlLabel>
                          <div id="custom-container" style={{ position: 'relative' }}>
                            <SelectPicker
                              id="ColorName"
                              name="ColorName"
                              value={data5.ColorName || selectedColorName?.ColorName || ''}
                              onChange={(value) => {
                                handleInputChange('ColorName', value, 0);
                                setSelectedColorName({ ColorName: value });
                              }}
                              data={colordata}
                              placeholder={`Select ${label[0]?.attributes?.color}`}
                              labelKey="label"
                              valueKey="label"
                              placement="auto"
                              block
                              container={() => document.getElementById("custom-container")}
                              menuMaxHeight={180}
                              menuStyle={{ width: 200 }}
                              onOpen={() => fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor)}
                              renderExtraFooter={() => (
                                <Stack justifyContent="space-between">
                                  <Input
                                    placeholder={`Add ${label[0]?.attributes?.color}`}
                                    value={color?.ColorName || ""}
                                    onChange={(value) => handleInputChange5("ColorName", value, 0)}
                                  />
                                  <IconButton
                                    icon={<PlusIcon />}
                                    appearance="primary"
                                    color="cyan"
                                    onClick={(e) => submit5(e, setData5)}
                                  />
                                </Stack>
                              )}
                            />

                          </div>
                          {/* <Input id='Color' name="Color" value={data5 && data5.Color ? data5.Color : ''} onChange={value => handleInputChange('Color', value, 0)} /> */}
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                        <Form.Group controlId="input-group">
                          <Form.ControlLabel>{label[0]?.attributes?.finish}</Form.ControlLabel>
                          <div id="custom-container" style={{ position: 'relative' }}>
                            <SelectPicker
                              id="FinishName"
                              name="FinishName"
                              value={data5.FinishName || selectedFinishName?.FinishName || ""}
                              onChange={(value) => {
                                handleInputChange("FinishName", value, 0);
                                setSelectedFinishName({ FinishName: value });
                              }}
                              data={finishdata}
                              placeholder={`Select ${label[0]?.attributes?.finish}`}
                              labelKey="label"
                              valueKey="label"
                              placement="auto"
                              block
                              container={() => document.getElementById("custom-container")}
                              menuMaxHeight={180}
                              menuStyle={{ width: 200 }}
                              onOpen={() => fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin)}
                              renderExtraFooter={() => (
                                <Stack justifyContent="space-between">
                                  <Input
                                    placeholder={`Add ${label[0]?.attributes?.finish}`}
                                    value={finish?.FinishName || ""}
                                    onChange={(value) => handleInputChange4("FinishName", value, 0)}
                                  />
                                  <IconButton
                                    icon={<PlusIcon />}
                                    appearance="primary"
                                    color="cyan"
                                    onClick={(e) => submit4(e, setData5)}
                                  />
                                </Stack>
                              )}
                            />

                          </div>
                          {/* <Input id='Finish' name="Finish" value={data5 && data5.Finish ? data5.Finish : ''} onChange={value => handleInputChange('Finish', value, 0)} /> */}
                        </Form.Group>
                      </FlexboxGrid.Item>
                    </>
                  )}
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>
                        {label[0]?.attributes?.HSN + data5.HSNCode}
                      </Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          id="HSNCode"
                          name="HSNCode"
                          value={data5?.HSNCode}
                          onChange={value => handleInputChange('HSNCode', value, 0)}
                          data={hsndata}
                          placeholder={`Select ${label[0]?.attributes?.HSN}`}
                          placement="autoVerticalStart"
                          block
                          container={() => document.getElementById('custom-container')}
                          menuMaxHeight={180}
                          menuStyle={{ width: 300 }}
                          onOpen={() => fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn)}
                          // renderMenuItem={(label, item) => (
                          //   <div>
                          //     <span>{item.value}</span> - <span>{item.description}</span>
                          //   </div>
                          // )}
                          // renderValue={(value, item) => (
                          //   <div>
                          //     <span>{value}</span> - <span>{item?.description}</span>
                          //   </div>
                          // )}
                          renderExtraFooter={() => (
                            <div style={{ width: 300 }}>
                              <Stack justifyContent="space-between" spacing={3}>
                                <InputNumber
                                  step={null}
                                  placeholder={`Add ${label[0]?.attributes?.HSN}`}
                                  value={hscode && hscode.hscode ? hscode.hscode : ''}
                                  onChange={value => handleInputChange6('hscode', value, 0)}
                                  style={{ width: 125 }}
                                />
                                <InputNumber
                                  step={null}
                                  placeholder="GstRate"
                                  value={hscode && hscode.GstRate ? hscode.GstRate : ''}
                                  onChange={value => handleInputChange6('GstRate', value, 0)}
                                  style={{ width: 55 }}
                                />
                                <Input
                                  placeholder="Description"
                                  value={hscode && hscode.Description ? hscode.Description : ''}
                                  onChange={value => handleInputChange6('Description', value, 0)}
                                  style={{ width: 55 }}
                                />
                                <IconButton
                                  icon={<PlusIcon />}
                                  appearance="primary"
                                  color="cyan"
                                  onClick={submit6}
                                />
                              </Stack>
                            </div>
                          )}
                        />
                      </div>
                      {/* <Input id='HSNCode' name="HSNCode" value={data5 && data5.HSNCode ? data5.HSNCode : ''} onChange={value => handleInputChange('HSNCode', value, 0)} /> */}
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <FlexboxGrid style={{ marginBottom: '20px' }}>
                  {/* <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.NetWgt}</Form.ControlLabel>
                      <InputNumber
                        step={null}
                        style={{ width: 'auto' }}
                        id="NetWeight"
                        name="NetWeight"
                        value={data5 && data5.NetWeight ? data5.NetWeight : 0}
                        onChange={value => handleInputChange('NetWeight', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item> 
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.GrossWgt}</Form.ControlLabel>
                      <InputNumber
                        step={null}
                        style={{ width: 'auto' }}
                        id="GrossWeight"
                        name="GrossWeight"
                        value={data5 && data5.GrossWeight ? data5.GrossWeight : 0}
                        onChange={value => handleInputChange('GrossWeight', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item> */}

                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.NetWgt}</Form.ControlLabel>
                      <Input
                        style={{ width: 'auto' }}
                        id="NetWeight"
                        name="NetWeight"
                        value={data5?.NetWeight || ''} // store typed value as string
                        onChange={value => {
                          // Optional: prevent negative numbers
                          if (value !== '' && parseFloat(value) < 0) {
                            handleOpenne();
                            return;
                          }
                          setData5(prevData => ({
                            ...prevData,
                            NetWeight: value
                          }));
                        }}
                        placeholder="Enter weight"
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.GrossWgt}</Form.ControlLabel>
                      <Input
                        style={{ width: 'auto' }}
                        id="GrossWeight"
                        name="GrossWeight"
                        value={data5?.GrossWeight || ''} // store as string to preserve trailing zeros
                        onChange={value => {
                          // Optional: prevent negative numbers
                          if (value !== '' && parseFloat(value) < 0) {
                            handleOpenne();
                            return;
                          }

                          // Update state
                          setData5(prevData => ({
                            ...prevData,
                            GrossWeight: value
                          }));
                        }}
                        placeholder="Enter weight"
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.MOQ}</Form.ControlLabel>
                      <Input
                        id="MOQ"
                        name="MOQ"
                        type="number" // Ensure numeric input
                        value={data5.MOQ !== undefined ? data5.MOQ : ''}
                        onChange={value => handleInputChange('MOQ', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginTop: '20px' }}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.Collection}</Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <CheckPicker
                          data={collectiondata}
                          id="MaterialCollection"
                          name="MaterialCollection"
                          value={data5?.MaterialCollection?.map(
                            collection => collection.MatCollectionNm
                          )}
                          onChange={value => handleInputChange('MaterialCollection', value, 0)}
                          placeholder={`Select ${label[0]?.attributes?.Collection}`}
                          labelKey="label"
                          valueKey="label"
                          placement="autoVerticalStart"
                          container={() => document.getElementById('custom-container')}
                          menuStyle={{ width: 200 }}
                          block
                          onOpen={() =>
                            fetchMaterialCollection(
                              setCollectiondata,
                              isLoadingcoll,
                              setIsLoadingcoll
                            )
                          }
                          renderExtraFooter={() => (
                            <Stack justifyContent="space-between">
                              <StackItem grow={1}>
                                <Input
                                  placeholder={`Add ${label[0]?.attributes?.Collection}`}
                                  value={
                                    collection && collection.MatCollectionName
                                      ? collection.MatCollectionName
                                      : ''
                                  }
                                  onChange={value =>
                                    handleInputChange3('MatCollectionName', value, 0)
                                  }
                                />
                              </StackItem>
                              <IconButton
                                icon={<PlusIcon />}
                                appearance="primary"
                                color="cyan"
                                onClick={submit3}
                              />
                            </Stack>
                          )}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginTop: '20px' }}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.Season}</Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          data={seasondata}
                          id="Season"
                          name="Season"
                          value={data5 && data5.Season ? data5.Season : ''}
                          onChange={value => handleInputChange('Season', value, 0)}
                          onOpen={() =>
                            fetchSeason(setSeasondata, isLoadingseason, setIsLoadingseason)
                          }
                          container={() => document.getElementById('custom-container')}
                          menuStyle={{ width: 200 }}
                          block
                          placement="autoVerticalStart"
                          renderExtraFooter={() => (
                            <Stack justifyContent="space-between">
                              <StackItem grow={1}>
                                <Input
                                  placeholder={`Add ${label[0]?.attributes?.Season}`}
                                  value={season && season.SeasonName ? season.SeasonName : ''}
                                  onChange={value => handleInputChange9('SeasonName', value, 0)}
                                />
                              </StackItem>
                              <IconButton
                                icon={<PlusIcon />}
                                appearance="primary"
                                color="cyan"
                                onClick={submit9}
                              />
                            </Stack>
                          )}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginTop: '20px' }}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.P_Technique}</Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          data={ptechdata}
                          id="P_Technique"
                          name="P_Technique"
                          labelKey="label"
                          valueKey="label"
                          placement="autoVerticalStart"
                          value={data5 && data5.P_Technique ? data5.P_Technique : ''}
                          onChange={value => handleInputChange('P_Technique', value, 0)}
                          onOpen={() =>
                            fetchPtechnique(setPtechdata, isLoadingptech, setIsLoadingptech)
                          }
                          container={() => document.getElementById('custom-container')}
                          menuStyle={{ width: 200 }}
                          block
                          renderExtraFooter={() => (
                            <Stack justifyContent="space-between">
                              <StackItem grow={1}>
                                <Input
                                  placeholder={`Add ${label[0]?.attributes?.P_Technique}`}
                                  value={ptech && ptech.PTechName ? ptech.PTechName : ''}
                                  onChange={value => handleInputChange10('PTechName', value, 0)}
                                />
                              </StackItem>
                              <IconButton
                                icon={<PlusIcon />}
                                appearance="primary"
                                color="cyan"
                                onClick={submit10}
                              />
                            </Stack>
                          )}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <FlexboxGrid justify="space-around" style={{ marginBottom: '20px' }}>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.Currency}</Form.ControlLabel>
                      <div id="custom-container" style={{ position: 'relative' }}>
                        <SelectPicker
                          data={curr}
                          cleanable={false}
                          id="SellingPriceCurrency"
                          name="SellingPriceCurrency"
                          placement="auto"
                          // labelKey="label"
                          // valueKey="value"
                          container={() => document.getElementById('custom-container')}
                          value={
                            data5 && data5.SellingPriceCurrency ? data5.SellingPriceCurrency : ''
                          }
                          onChange={value => handleInputChange('SellingPriceCurrency', value, 0)}
                          block
                          onOpen={fetchDatacurr}
                        />
                      </div>
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.CurRate}</Form.ControlLabel>
                      <Input
                        id="SellingPriceUnit"
                        name="SellingPriceUnit"
                        value={data5 && data5.SellingPriceUnit ? data5.SellingPriceUnit : ''}
                        onChange={value => handleInputChange('SellingPriceUnit', value, 0)}
                        readOnly
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.SalePrice}</Form.ControlLabel>
                      <InputNumber
                        step={null}
                        style={{ width: 'auto' }}
                        id="SellingPrice"
                        name="SellingPrice"
                        value={data5 && data5.SellingPrice ? data5.SellingPrice : 0}
                        onChange={value => handleInputChange('SellingPrice', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.SalePriceINR}</Form.ControlLabel>
                      <InputNumber
                        readOnly
                        style={{ width: 'auto' }}
                        id="ProductCost"
                        name="ProductCost"
                        value={data5 && data5.ProductCost ? data5.ProductCost : 0}
                        onChange={value => handleInputChange('ProductCost', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <FlexboxGrid justify="space-around" style={{ marginBottom: '15px' }}>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.ProductDesigner}</Form.ControlLabel>
                      <Input
                        id="ProductDesigner"
                        name="ProductDesigner"
                        autocomplete="off"
                        value={data5 && data5.ProductDesigner ? data5.ProductDesigner : ''}
                        onChange={value => handleInputChange('ProductDesigner', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.MadeBy}</Form.ControlLabel>
                      <Input
                        id="MadeBy"
                        name="MadeBy"
                        autocomplete="off"
                        value={data5 && data5.MadeBy ? data5.MadeBy : ''}
                        onChange={value => handleInputChange('MadeBy', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <Form.Group controlId="input-group">
                      <Form.ControlLabel>{label[0]?.attributes?.ProductRemark}</Form.ControlLabel>
                      <Input
                        id="Product_Remark"
                        name="Product_Remark"
                        autocomplete="off"
                        value={data5 && data5.Product_Remark ? data5.Product_Remark : ''}
                        onChange={value => handleInputChange('Product_Remark', value, 0)}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <Form.Group controlId="input-group">
                  <Form.ControlLabel>{label[0]?.attributes?.searchKeyword}</Form.ControlLabel>
                  <Input
                    id="SearchKeyword"
                    name="SearchKeyword"
                    autocomplete="off"
                    value={data5 && data5.SearchKeyword ? data5.SearchKeyword : ''}
                    onChange={value => handleInputChange('SearchKeyword', value, 0)}
                  />
                </Form.Group>

                {/* <button type='submit' onClick={submit}> Submit</button> */}
                <BuyerExclusiveProduct
                  {...{
                    data5,
                    label,
                    buyeerdata,
                    handleInputChange,
                    fetchBuyers,
                    setBuyeerdata,
                    isLoadingbu,
                    setIsLoadingbu,
                    showInputs,
                    setShowInputs
                  }}
                />

                <ProductionDetails
                  {...{
                    data5,
                    addMaterial,
                    compdata,
                    siii,
                    finishdata,
                    materialdata,
                    handleProductionDetailChange,
                    fetchFinishes,
                    setFinishData,
                    isLoadingfin,
                    setIsLoadingfin,
                    deleteMaterial,
                    label
                  }}
                />
              </Form>
            </FlexboxGrid.Item>
          </FlexboxGrid>
          <Modal
            backdrop="static"
            role="alertdialog"
            open={openne}
            onClose={handleClosene}
            size="xs"
          >
            <Modal.Body>
              <RemindIcon
                style={{ color: '#ffb300', fontSize: 18, marginRight: '10px', marginTop: '-4px' }}
              />
              Cannot Allowed Negitive Value.
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClosene} appearance="primary" color="cyan">
                Ok
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div style={{ display: step === 1 ? "block" : "none" }}>
          {isDataLoading ? (
            <div style={overlayStyle}>
              <Loader size="large" />
            </div>
          ) : (
            <ProductFamily
              {...{
                data5,
                //Sslecters Data
                colordata,
                finishdata,
                variantData,
                size,
                materialdata,
                handleUploadVarImage,
                handleOpenne,
                handleOpencbm,
                handleRemoveVariant,
                //State manage
                showPname,
                showDesc,
                showFinish,
                showSize,
                showLength,
                showWidth,
                showHeight,
                showMoq,
                showNTW,
                showGRW,
                showMat,
                showbuyersku,
                fileInfo,
                showColor,
                label,
                variantttdata,
                setVariantData,
                // For Update Product
                updateid,
                // For Drawer
                open,
                numVariants,
                setOpen,
                setPName,
                setShowColor,
                setShowLength,
                setShowWidth,
                setShowHeight,
                setShowFinish,
                setShowSize,
                setShowDesc,
                setShowMoq,
                setShowNTW,
                setShowGRW,
                handleAddVariants,
                setNumVariants,
                setShowMat
              }}
            />
          )}
        </div>
        <div style={{ display: step === 2 ? "block" : "none" }} >
          {isDataLoading ? (
            <div style={overlayStyle}>
              <Loader size="large" />
            </div>
          ) : (
            <PackageLoadability
              {...{
                data5,
                setData5,
                //data of Inputes
                cartontype,
                siii,
                //Value of the InputeNumber
                totalcbm1,
                totalcft,
                feet20,
                feet40,
                feet20hc,
                //Function to handle inputes
                handleInputChange,
                label,
                addPackaging,
                setTotalCbm,
                setTotalCFT,
                setFeet20,
                setFeet40,
                setFeet20hc
              }}
            />)}
        </div>

        <Stack justifyContent="flex-end" className="button">
          <Panel>
            <ButtonGroup>
              <Button onClick={onPrevious} disabled={step === 0} active>
                Previous
              </Button>
              {step === 2 ? (
                <Button
                  color="cyan"
                  appearance="primary"
                  onClick={e => submit(e)}
                  disabled={productsaved || isFinalStepLoading}
                  loading={isLoading1 || isFinalStepLoading}
                >
                  Save
                </Button>
              ) : (
                <Button color="cyan" appearance="ghost" onClick={onNext} disabled={step === 2}>
                  Next
                </Button>
              )}
              {step === 0 && (
                // <Button  appearance="primary" onClick={submit} loading={isLoading1}>
                //   Save
                // </Button>
                <a
                  href={`/${ugr}/products-create?showPopup=true`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    if (!(e.ctrlKey || e.metaKey)) {
                      e.preventDefault();
                      // Normal click behavior
                      // onChange1();
                      handleClicktrain();
                    }

                    // Ctrl/Cmd click = let browser handle it (opens in background tab)
                  }}
                >
                  <Button appearance="primary" color="cyan" onClick={submitStep0} disabled={processing} loading={isLoading1}> Save </Button>
                </a>
              )}
              {step === 1 && (
                <Button
                  color="cyan"
                  appearance="primary"
                  onClick={() => {
                    submit({ preventDefault: () => { } });

                    // if (variantImageChanged == false) {
                    //   console.log("third")
                    //   toaster.push(
                    //     <Message showIcon type="error">
                    //       Please change all variant image.
                    //     </Message>,
                    //     { placement: 'topCenter' }
                    //   );
                    // } else {
                    //   submit({ preventDefault: () => { } });
                    // }
                  }}
                  loading={isLoading1 || isVariantSubmitting}
                  disabled={isLoading1 || isVariantSubmitting}
                >
                  Save
                </Button>
              )}
            </ButtonGroup>
          </Panel>
          <Modal open={open4} onClose={handleClose4} backdrop="static">
            <Modal.Header>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Stack direction="column">
                <Player autoplay loop src={animati} style={{ height: '250px', width: '250px' }} />
                <b>Product Saved Successfully</b>
              </Stack>
            </Modal.Body>
            <Modal.Footer>
              <Stack alignItems="flex-end" justifyContent="flex-end">
                <Button appearance="primary" color="cyan" onClick={handleClose4}>
                  Ok
                </Button>
              </Stack>
            </Modal.Footer>
          </Modal>
          <Modal open={open5} onClose={handleClose5} backdrop="static">
            <Modal.Header>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Stack direction="column">
                <Player autoplay loop src={animati} style={{ height: '250px', width: '250px' }} />
                <b>Product Update Successfully</b>
              </Stack>
            </Modal.Body>
            <Modal.Footer>
              <Stack alignItems="flex-end" justifyContent="flex-end">
                <Button
                  appearance="primary"
                  color="cyan"
                  onClick={() => {
                    handleClose5();
                    window.location.href = `/${ugr}/products-create?pId=${iddd}&id=${vartid}`; // This removes params and reloads
                  }}
                >
                  Ok
                </Button>
              </Stack>
            </Modal.Footer>
          </Modal>
        </Stack>
        <VariantPacking
          variantData={variantData}
          setVariantData={setVariantData}
          cbmeditdata={cbmeditdata}
          showModal={showModal}
          setShowModal={setShowModal}
        />
        <Footer />
      </Container>
    </>
  );
};

export default Addprduct;
